export default {
  12: {
    isFetching: false,
    data: [
      {
        state: {
          auto: false,
          on: false
        },
        change: {
          auto: false,
          on: false
        },
        timestamp: new Date('2017-06-06T12:34:14.443Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          auto: true
        },
        timestamp: new Date('2017-06-06T12:36:25.402Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-06T12:36:28.586Z')
      },
      {
        state: {
          auto: false,
          on: false
        },
        change: {
          auto: false,
          on: false
        },
        timestamp: new Date('2017-06-06T14:05:04.107Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          auto: true
        },
        timestamp: new Date('2017-06-06T14:35:11.685Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-06T14:35:21.418Z')
      },
      {
        state: {
          auto: false,
          on: false
        },
        change: {
          auto: false,
          on: false
        },
        timestamp: new Date('2017-06-06T14:38:12.756Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          auto: true
        },
        timestamp: new Date('2017-06-06T15:58:47.923Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-06T21:30:41.869Z')
      },
      {
        state: {
          auto: false,
          on: false
        },
        change: {
          auto: false,
          on: false
        },
        timestamp: new Date('2017-06-07T13:53:09.493Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          auto: true
        },
        timestamp: new Date('2017-06-07T16:03:02.512Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-07T21:30:45.429Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-08T15:12:50.761Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-08T15:17:43.304Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-08T15:30:31.569Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-08T21:30:45.704Z')
      },
      {
        state: {
          auto: false,
          on: false
        },
        change: {
          auto: false,
          on: false
        },
        timestamp: new Date('2017-06-08T21:35:31.151Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          auto: true,
          on: true
        },
        timestamp: new Date('2017-06-08T21:36:50.770Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T00:26:56.725Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T00:31:35.082Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T02:43:51.397Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T02:49:00.960Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T05:13:41.075Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T05:19:53.916Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T07:09:30.772Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T07:15:13.681Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T08:47:24.250Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T08:53:14.535Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T10:33:19.101Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T10:39:02.080Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T12:31:18.011Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T12:37:00.977Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T13:50:10.702Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T13:56:16.698Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T14:51:18.263Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T14:57:12.323Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-09T15:30:32.964Z')
      },
      {
        state: {
          auto: false,
          on: true
        },
        change: {
          auto: false,
          on: true
        },
        timestamp: new Date('2017-06-09T15:58:55.646Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          auto: true,
          on: false
        },
        timestamp: new Date('2017-06-09T16:00:15.599Z')
      },
      {
        state: {
          auto: false,
          on: false
        },
        change: {
          auto: false
        },
        timestamp: new Date('2017-06-09T19:40:50.371Z')
      },
      {
        state: {
          auto: false,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T19:40:56.942Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          auto: true,
          on: false
        },
        timestamp: new Date('2017-06-09T19:41:00.224Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-09T21:30:44.327Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-10T01:50:18.060Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-10T01:54:54.238Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-10T14:37:29.696Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-10T14:42:25.928Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-10T15:30:33.187Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-10T21:30:45.624Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T01:57:22.114Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T02:03:38.058Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T05:04:15.844Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T05:10:24.992Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T09:09:41.533Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T09:15:21.234Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T12:54:21.113Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T12:59:30.616Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T14:03:56.380Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T14:10:05.820Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T14:39:22.820Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T14:45:48.583Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T15:09:41.060Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T15:16:20.143Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T15:30:34.903Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T21:30:49.357Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T23:16:31.673Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-11T23:22:22.394Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-11T23:59:51.473Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T00:06:17.121Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T00:35:03.914Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T00:41:26.639Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T01:12:47.322Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T01:19:13.378Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T01:52:40.438Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T01:58:46.591Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T02:42:49.031Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T02:48:51.895Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T03:49:46.519Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T03:56:05.741Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T05:24:53.793Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T05:30:46.258Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T07:36:31.202Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T07:41:47.127Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T11:36:33.245Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T11:42:06.709Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T12:49:29.117Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T12:55:31.270Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T13:26:09.909Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T13:32:47.262Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T14:01:49.160Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T14:12:59.063Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T14:23:53.253Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T14:32:09.628Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T14:49:03.273Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T14:56:21.351Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T15:14:58.491Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T15:22:08.784Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T15:30:36.017Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T21:30:49.998Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-12T23:45:36.170Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-12T23:51:07.887Z')
      },
      {
        state: {
          auto: true,
          on: false
        },
        change: {
          on: false
        },
        timestamp: new Date('2017-06-13T00:50:38.334Z')
      },
      {
        state: {
          auto: true,
          on: true
        },
        change: {
          on: true
        },
        timestamp: new Date('2017-06-13T00:56:40.004Z')
      }
    ],
    error: null
  },
  2014: {
    isFetching: false,
    data: [
      {
        fullValue: 699,
        timestamp: new Date('2017-06-13T01:22:34.486Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-13T01:02:30.399Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-13T00:42:25.241Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-13T00:22:19.292Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-13T00:02:13.542Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T23:42:08.097Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-12T23:22:02.582Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-12T23:01:57.519Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-12T22:41:51.393Z')
      },
      {
        fullValue: 676,
        timestamp: new Date('2017-06-12T22:21:45.786Z')
      },
      {
        fullValue: 665,
        timestamp: new Date('2017-06-12T22:01:40.867Z')
      },
      {
        fullValue: 638,
        timestamp: new Date('2017-06-12T21:41:35.988Z')
      },
      {
        fullValue: 618,
        timestamp: new Date('2017-06-12T21:22:30.953Z')
      },
      {
        fullValue: 618,
        timestamp: new Date('2017-06-12T21:02:25.546Z')
      },
      {
        fullValue: 608,
        timestamp: new Date('2017-06-12T20:42:19.458Z')
      },
      {
        fullValue: 598,
        timestamp: new Date('2017-06-12T20:22:13.866Z')
      },
      {
        fullValue: 597,
        timestamp: new Date('2017-06-12T20:02:08.605Z')
      },
      {
        fullValue: 598,
        timestamp: new Date('2017-06-12T19:42:03.592Z')
      },
      {
        fullValue: 598,
        timestamp: new Date('2017-06-12T19:21:58.041Z')
      },
      {
        fullValue: 602,
        timestamp: new Date('2017-06-12T19:01:52.903Z')
      },
      {
        fullValue: 603,
        timestamp: new Date('2017-06-12T18:40:47.527Z')
      },
      {
        fullValue: 607,
        timestamp: new Date('2017-06-12T18:20:43.121Z')
      },
      {
        fullValue: 596,
        timestamp: new Date('2017-06-12T18:00:37.995Z')
      },
      {
        fullValue: 615,
        timestamp: new Date('2017-06-12T17:40:32.687Z')
      },
      {
        fullValue: 623,
        timestamp: new Date('2017-06-12T17:19:30.102Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-12T16:59:26.542Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-12T16:39:23.602Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-12T16:19:20.513Z')
      },
      {
        fullValue: 668,
        timestamp: new Date('2017-06-12T15:59:18.326Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-12T15:39:13.706Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-12T15:19:09.141Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-12T14:59:05.203Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-12T14:39:01.745Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-12T14:18:57.461Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T13:48:25.332Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T13:28:20.504Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-12T13:08:15.511Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-12T12:48:09.913Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T12:28:04.439Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-12T12:07:58.829Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-12T11:47:53.837Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-12T11:27:50.415Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T11:07:45.886Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T10:47:42.427Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T10:27:38.659Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T10:07:33.679Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T09:47:30.063Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T09:27:26.110Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-12T09:07:21.945Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-12T08:47:16.650Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-12T08:27:10.816Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-12T08:07:03.195Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-12T07:46:55.675Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-12T07:26:50.958Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T07:06:44.440Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T06:46:39.890Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T06:26:32.273Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T06:06:24.993Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-12T05:46:19.744Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T05:26:13.005Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-12T05:06:06.877Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T04:46:01.715Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-12T04:25:54.080Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-12T04:05:49.625Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-12T03:45:43.248Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T03:25:37.723Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-12T03:05:33.285Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-12T02:45:26.656Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T02:25:20.089Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-12T02:05:15.304Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T01:45:10.525Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-12T01:25:03.464Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T01:04:57.319Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-12T00:44:53.267Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T00:24:47.662Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-12T00:04:40.788Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-11T23:44:35.687Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-11T23:24:32.971Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-11T23:04:28.558Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-11T22:43:25.031Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-11T22:23:21.693Z')
      },
      {
        fullValue: 676,
        timestamp: new Date('2017-06-11T22:03:19.272Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-11T21:43:14.756Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-11T21:23:08.598Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-11T21:03:02.303Z')
      },
      {
        fullValue: 617,
        timestamp: new Date('2017-06-11T20:42:55.640Z')
      },
      {
        fullValue: 618,
        timestamp: new Date('2017-06-11T20:22:49.469Z')
      },
      {
        fullValue: 620,
        timestamp: new Date('2017-06-11T20:02:43.002Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-11T19:42:36.420Z')
      },
      {
        fullValue: 618,
        timestamp: new Date('2017-06-11T19:22:30.814Z')
      },
      {
        fullValue: 621,
        timestamp: new Date('2017-06-11T19:02:25.240Z')
      },
      {
        fullValue: 621,
        timestamp: new Date('2017-06-11T18:42:18.755Z')
      },
      {
        fullValue: 622,
        timestamp: new Date('2017-06-11T18:22:12.440Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-11T18:02:06.142Z')
      },
      {
        fullValue: 631,
        timestamp: new Date('2017-06-11T17:41:59.328Z')
      },
      {
        fullValue: 634,
        timestamp: new Date('2017-06-11T17:21:52.997Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-11T17:01:46.849Z')
      },
      {
        fullValue: 645,
        timestamp: new Date('2017-06-11T16:41:40.353Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-11T16:21:34.165Z')
      },
      {
        fullValue: 667,
        timestamp: new Date('2017-06-11T16:01:27.401Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-11T15:41:21.077Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-11T15:20:14.502Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-11T15:00:09.038Z')
      },
      {
        fullValue: 701,
        timestamp: new Date('2017-06-11T14:40:04.389Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-11T14:19:57.876Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-11T13:59:52.105Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-11T13:39:46.050Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-11T13:19:38.963Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-11T12:59:34.380Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-11T12:39:29.055Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-11T12:19:23.457Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-11T11:59:17.063Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-11T11:39:11.185Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-11T11:19:04.809Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-11T10:59:00.491Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-11T10:38:54.763Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-11T10:18:49.161Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-11T09:58:41.666Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-11T09:38:35.997Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-11T09:18:29.889Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-11T08:58:23.985Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-11T08:38:17.749Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-11T08:18:10.987Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-11T07:58:04.981Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-11T07:37:59.032Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-11T07:17:52.183Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-11T06:57:46.038Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-11T06:37:39.889Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-11T06:17:32.934Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-11T05:57:25.258Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-11T05:37:20.534Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-11T05:17:13.490Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-11T04:57:07.427Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-11T04:37:01.915Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-11T04:16:56.085Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-11T03:56:49.226Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-11T03:36:43.325Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-11T03:16:38.581Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-11T02:56:31.843Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-11T02:36:26.322Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-11T02:16:20.799Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-11T01:56:14.639Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-11T01:36:08.695Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-11T01:16:02.467Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-11T00:55:56.489Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-11T00:35:50.394Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-11T00:15:43.771Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T23:55:38.064Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-10T23:35:31.364Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-10T23:15:25.391Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-10T22:55:19.197Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-10T22:35:14.135Z')
      },
      {
        fullValue: 673,
        timestamp: new Date('2017-06-10T22:15:06.865Z')
      },
      {
        fullValue: 660,
        timestamp: new Date('2017-06-10T21:55:01.013Z')
      },
      {
        fullValue: 615,
        timestamp: new Date('2017-06-10T21:34:55.047Z')
      },
      {
        fullValue: 609,
        timestamp: new Date('2017-06-10T21:14:51.338Z')
      },
      {
        fullValue: 610,
        timestamp: new Date('2017-06-10T20:54:48.647Z')
      },
      {
        fullValue: 611,
        timestamp: new Date('2017-06-10T20:34:45.928Z')
      },
      {
        fullValue: 611,
        timestamp: new Date('2017-06-10T20:14:43.451Z')
      },
      {
        fullValue: 611,
        timestamp: new Date('2017-06-10T19:54:41.019Z')
      },
      {
        fullValue: 614,
        timestamp: new Date('2017-06-10T19:34:37.936Z')
      },
      {
        fullValue: 617,
        timestamp: new Date('2017-06-10T19:14:35.196Z')
      },
      {
        fullValue: 618,
        timestamp: new Date('2017-06-10T18:54:31.643Z')
      },
      {
        fullValue: 620,
        timestamp: new Date('2017-06-10T18:34:26.074Z')
      },
      {
        fullValue: 622,
        timestamp: new Date('2017-06-10T18:14:23.590Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-10T17:54:20.002Z')
      },
      {
        fullValue: 631,
        timestamp: new Date('2017-06-10T17:34:16.297Z')
      },
      {
        fullValue: 634,
        timestamp: new Date('2017-06-10T17:14:13.462Z')
      },
      {
        fullValue: 642,
        timestamp: new Date('2017-06-10T16:54:09.955Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-10T16:34:06.340Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-10T16:14:03.529Z')
      },
      {
        fullValue: 669,
        timestamp: new Date('2017-06-10T15:54:01.017Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-10T15:33:58.180Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-10T15:13:51.796Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T14:53:45.278Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-10T14:33:40.857Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-10T14:13:35.002Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-10T13:53:28.680Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-10T13:33:23.024Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-10T13:13:17.763Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T12:53:10.829Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-10T12:33:05.334Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-10T12:12:59.099Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-10T11:52:53.880Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-10T11:32:46.723Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-10T11:12:38.811Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-10T10:52:34.295Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-10T10:32:29.365Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-10T10:12:25.012Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T09:52:18.187Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-10T09:31:13.190Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-10T09:11:06.647Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-10T08:51:00.312Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T08:30:54.964Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-10T08:10:48.904Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-10T07:50:42.167Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-10T07:30:34.361Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-10T07:10:27.811Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T06:50:24.248Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-10T06:30:21.703Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T06:10:17.041Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-10T05:50:10.123Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-10T05:30:04.628Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-10T05:09:59.723Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-10T04:49:56.027Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-10T04:29:52.873Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-10T04:09:49.180Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-10T03:49:45.562Z')
      },
      {
        fullValue: 683,
        timestamp: new Date('2017-06-10T03:29:42.492Z')
      },
      {
        fullValue: 683,
        timestamp: new Date('2017-06-10T03:09:38.925Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-10T02:49:32.408Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-10T02:29:26.543Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-10T02:09:21.743Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-10T01:49:15.450Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-10T01:29:11.875Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T01:09:07.968Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-10T00:49:10.033Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-10T00:30:24.943Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-10T00:12:17.509Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-09T23:51:54.672Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-09T23:31:48.108Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-09T23:11:42.825Z')
      },
      {
        fullValue: 675,
        timestamp: new Date('2017-06-09T22:50:37.333Z')
      },
      {
        fullValue: 674,
        timestamp: new Date('2017-06-09T22:30:31.551Z')
      },
      {
        fullValue: 672,
        timestamp: new Date('2017-06-09T22:10:25.398Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-09T21:46:56.125Z')
      },
      {
        fullValue: 630,
        timestamp: new Date('2017-06-09T21:26:50.226Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-09T21:06:44.526Z')
      },
      {
        fullValue: 610,
        timestamp: new Date('2017-06-09T20:46:38.811Z')
      },
      {
        fullValue: 609,
        timestamp: new Date('2017-06-09T20:26:32.895Z')
      },
      {
        fullValue: 611,
        timestamp: new Date('2017-06-09T20:06:26.043Z')
      },
      {
        fullValue: 614,
        timestamp: new Date('2017-06-09T19:46:19.739Z')
      },
      {
        fullValue: 616,
        timestamp: new Date('2017-06-09T19:26:14.781Z')
      },
      {
        fullValue: 620,
        timestamp: new Date('2017-06-09T19:06:10.429Z')
      },
      {
        fullValue: 624,
        timestamp: new Date('2017-06-09T18:46:05.832Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-09T18:26:00.164Z')
      },
      {
        fullValue: 631,
        timestamp: new Date('2017-06-09T18:05:53.626Z')
      },
      {
        fullValue: 635,
        timestamp: new Date('2017-06-09T17:45:48.057Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-09T17:25:41.379Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-09T17:05:34.693Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-09T16:45:27.966Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-09T16:25:21.118Z')
      },
      {
        fullValue: 672,
        timestamp: new Date('2017-06-09T16:05:14.670Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-09T15:45:11.086Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-09T15:25:06.615Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-09T15:05:01.727Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T14:45:57.694Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-09T14:25:52.095Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-09T14:05:44.667Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-09T13:45:38.046Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-09T13:25:32.434Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-09T13:05:26.166Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-09T12:45:19.023Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T12:25:13.461Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-09T12:05:08.633Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T11:45:00.823Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-09T11:24:53.679Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-09T11:04:48.919Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-09T10:44:41.192Z')
      },
      {
        fullValue: 696,
        timestamp: new Date('2017-06-09T10:24:35.084Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T10:04:28.542Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-09T09:44:23.283Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-09T09:24:15.566Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-09T09:04:08.046Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-09T08:44:02.279Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-09T08:23:55.619Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T08:03:47.942Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-09T07:43:42.753Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-09T07:23:35.105Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T07:03:29.098Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T06:43:23.004Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T06:23:17.353Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-09T06:03:09.789Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-09T05:43:02.100Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-09T05:22:57.075Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-09T05:02:51.157Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-09T04:42:44.901Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-09T04:22:38.561Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-09T04:02:34.037Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-09T03:42:27.307Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-09T03:22:19.639Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-09T03:02:13.069Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-09T02:42:08.660Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-09T02:22:02.693Z')
      },
      {
        fullValue: 694,
        timestamp: new Date('2017-06-09T02:01:57.061Z')
      },
      {
        fullValue: 695,
        timestamp: new Date('2017-06-09T01:41:50.541Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-09T01:21:43.421Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-09T01:01:35.927Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-09T00:41:28.761Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-09T00:21:23.873Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-09T00:01:17.408Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-08T23:41:11.386Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-08T23:21:06.227Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-08T23:01:01.330Z')
      },
      {
        fullValue: 668,
        timestamp: new Date('2017-06-08T22:40:53.517Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-08T22:20:46.266Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-08T22:00:40.642Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-08T21:40:34.607Z')
      },
      {
        fullValue: 601,
        timestamp: new Date('2017-06-08T21:20:30.134Z')
      },
      {
        fullValue: 602,
        timestamp: new Date('2017-06-08T21:00:26.398Z')
      },
      {
        fullValue: 600,
        timestamp: new Date('2017-06-08T20:40:20.971Z')
      },
      {
        fullValue: 601,
        timestamp: new Date('2017-06-08T20:20:14.408Z')
      },
      {
        fullValue: 603,
        timestamp: new Date('2017-06-08T20:00:09.018Z')
      },
      {
        fullValue: 605,
        timestamp: new Date('2017-06-08T19:40:02.506Z')
      },
      {
        fullValue: 605,
        timestamp: new Date('2017-06-08T19:19:55.993Z')
      },
      {
        fullValue: 603,
        timestamp: new Date('2017-06-08T18:59:50.834Z')
      },
      {
        fullValue: 607,
        timestamp: new Date('2017-06-08T18:39:47.601Z')
      },
      {
        fullValue: 609,
        timestamp: new Date('2017-06-08T18:19:45.157Z')
      },
      {
        fullValue: 612,
        timestamp: new Date('2017-06-08T17:59:42.089Z')
      },
      {
        fullValue: 617,
        timestamp: new Date('2017-06-08T17:40:38.334Z')
      },
      {
        fullValue: 622,
        timestamp: new Date('2017-06-08T17:20:33.287Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-08T17:00:29.717Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-08T16:40:25.950Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-08T16:20:23.259Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-08T16:00:20.582Z')
      },
      {
        fullValue: 675,
        timestamp: new Date('2017-06-08T15:40:17.831Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-08T15:20:14.953Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-08T15:00:08.565Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-08T14:40:03.127Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-08T14:19:57.347Z')
      },
      {
        fullValue: 688,
        timestamp: new Date('2017-06-08T13:59:51.132Z')
      },
      {
        fullValue: 688,
        timestamp: new Date('2017-06-08T13:39:45.549Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-08T13:19:39.570Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-08T12:59:33.222Z')
      },
      {
        fullValue: 683,
        timestamp: new Date('2017-06-08T12:39:27.480Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-08T12:19:20.651Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-08T11:59:14.911Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-08T11:39:07.982Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-08T11:19:01.178Z')
      },
      {
        fullValue: 688,
        timestamp: new Date('2017-06-08T10:58:55.017Z')
      },
      {
        fullValue: 688,
        timestamp: new Date('2017-06-08T10:38:49.539Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-08T10:18:44.040Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-08T09:57:37.272Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-08T09:37:31.661Z')
      },
      {
        fullValue: 683,
        timestamp: new Date('2017-06-08T09:17:26.112Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-08T08:57:21.079Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-08T08:37:14.706Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-08T08:17:08.624Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-08T07:57:02.953Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-08T07:35:57.466Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-08T07:13:49.854Z')
      },
      {
        fullValue: 683,
        timestamp: new Date('2017-06-08T06:53:42.776Z')
      },
      {
        fullValue: 688,
        timestamp: new Date('2017-06-08T06:33:38.198Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-08T06:11:31.186Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-08T05:51:25.594Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-08T05:31:19.499Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-08T05:11:13.733Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-08T04:51:07.615Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-08T04:31:02.004Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-08T04:06:54.115Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-08T03:46:48.377Z')
      },
      {
        fullValue: 674,
        timestamp: new Date('2017-06-08T03:26:42.565Z')
      },
      {
        fullValue: 676,
        timestamp: new Date('2017-06-08T03:06:36.667Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-08T02:46:30.808Z')
      },
      {
        fullValue: 683,
        timestamp: new Date('2017-06-08T02:26:23.735Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-08T02:06:16.685Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-08T01:46:09.705Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-08T01:26:04.166Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-08T01:05:57.971Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-08T00:45:53.217Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-08T00:25:46.893Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-08T00:05:41.403Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-07T23:45:35.988Z')
      },
      {
        fullValue: 674,
        timestamp: new Date('2017-06-07T23:25:29.483Z')
      },
      {
        fullValue: 667,
        timestamp: new Date('2017-06-07T23:05:23.837Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-07T22:45:16.894Z')
      },
      {
        fullValue: 665,
        timestamp: new Date('2017-06-07T22:25:09.773Z')
      },
      {
        fullValue: 660,
        timestamp: new Date('2017-06-07T22:05:02.650Z')
      },
      {
        fullValue: 629,
        timestamp: new Date('2017-06-07T21:44:55.767Z')
      },
      {
        fullValue: 592,
        timestamp: new Date('2017-06-07T21:24:50.155Z')
      },
      {
        fullValue: 593,
        timestamp: new Date('2017-06-07T21:04:45.711Z')
      },
      {
        fullValue: 595,
        timestamp: new Date('2017-06-07T20:44:41.889Z')
      },
      {
        fullValue: 597,
        timestamp: new Date('2017-06-07T20:24:36.581Z')
      },
      {
        fullValue: 599,
        timestamp: new Date('2017-06-07T20:04:32.331Z')
      },
      {
        fullValue: 602,
        timestamp: new Date('2017-06-07T19:44:30.353Z')
      },
      {
        fullValue: 605,
        timestamp: new Date('2017-06-07T19:20:53.206Z')
      },
      {
        fullValue: 609,
        timestamp: new Date('2017-06-07T19:00:48.916Z')
      },
      {
        fullValue: 614,
        timestamp: new Date('2017-06-07T18:38:51.621Z')
      },
      {
        fullValue: 621,
        timestamp: new Date('2017-06-07T18:15:14.418Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-07T17:53:10.469Z')
      },
      {
        fullValue: 635,
        timestamp: new Date('2017-06-07T17:33:04.474Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-07T17:13:00.618Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-07T16:51:55.500Z')
      },
      {
        fullValue: 674,
        timestamp: new Date('2017-06-07T16:31:51.477Z')
      },
      {
        fullValue: 701,
        timestamp: new Date('2017-06-07T16:06:24.878Z')
      },
      {
        fullValue: 723,
        timestamp: new Date('2017-06-07T15:46:19.704Z')
      },
      {
        fullValue: 720,
        timestamp: new Date('2017-06-07T15:27:14.182Z')
      },
      {
        fullValue: 716,
        timestamp: new Date('2017-06-07T15:07:09.454Z')
      },
      {
        fullValue: 707,
        timestamp: new Date('2017-06-07T14:47:03.892Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-07T14:26:58.106Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-07T14:06:51.765Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-07T13:46:47.495Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-07T13:26:41.270Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-07T13:06:35.232Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-07T12:46:29.429Z')
      },
      {
        fullValue: 665,
        timestamp: new Date('2017-06-07T12:26:23.561Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-07T12:06:19.449Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-07T11:46:13.167Z')
      },
      {
        fullValue: 667,
        timestamp: new Date('2017-06-07T11:26:07.078Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-07T11:06:00.597Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-07T10:45:55.351Z')
      },
      {
        fullValue: 639,
        timestamp: new Date('2017-06-07T10:25:50.697Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-07T10:05:44.763Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-07T09:45:38.847Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-07T09:25:32.338Z')
      },
      {
        fullValue: 658,
        timestamp: new Date('2017-06-07T09:05:26.946Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-07T08:45:20.936Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-07T08:25:15.544Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-07T08:05:10.716Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-07T07:45:05.325Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-07T07:24:59.847Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-07T07:04:53.517Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-07T06:44:49.574Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-07T06:24:43.934Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-07T06:04:37.950Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-07T05:44:31.647Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-07T05:24:27.955Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-07T05:04:22.058Z')
      },
      {
        fullValue: 642,
        timestamp: new Date('2017-06-07T04:44:16.285Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-07T04:24:11.453Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-07T04:03:05.778Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-07T03:43:00.049Z')
      },
      {
        fullValue: 639,
        timestamp: new Date('2017-06-07T03:21:53.316Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-07T03:01:49.578Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-07T02:41:43.588Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-07T02:21:37.957Z')
      },
      {
        fullValue: 642,
        timestamp: new Date('2017-06-07T02:01:32.651Z')
      },
      {
        fullValue: 645,
        timestamp: new Date('2017-06-07T01:41:26.939Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-07T01:21:21.722Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-07T01:01:15.819Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-07T00:41:10.351Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-07T00:21:05.146Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-07T00:00:59.540Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-06T23:40:54.586Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-06T23:20:49.233Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-06T23:00:44.183Z')
      },
      {
        fullValue: 637,
        timestamp: new Date('2017-06-06T22:40:39.485Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-06T22:20:33.611Z')
      },
      {
        fullValue: 635,
        timestamp: new Date('2017-06-06T22:00:28.379Z')
      },
      {
        fullValue: 623,
        timestamp: new Date('2017-06-06T21:40:22.546Z')
      },
      {
        fullValue: 596,
        timestamp: new Date('2017-06-06T21:20:18.381Z')
      },
      {
        fullValue: 587,
        timestamp: new Date('2017-06-06T21:00:14.421Z')
      },
      {
        fullValue: 596,
        timestamp: new Date('2017-06-06T20:40:10.602Z')
      },
      {
        fullValue: 587,
        timestamp: new Date('2017-06-06T20:20:06.729Z')
      },
      {
        fullValue: 595,
        timestamp: new Date('2017-06-06T20:00:02.707Z')
      },
      {
        fullValue: 588,
        timestamp: new Date('2017-06-06T19:39:59.578Z')
      },
      {
        fullValue: 584,
        timestamp: new Date('2017-06-06T19:16:13.106Z')
      },
      {
        fullValue: 601,
        timestamp: new Date('2017-06-06T18:56:09.087Z')
      },
      {
        fullValue: 586,
        timestamp: new Date('2017-06-06T18:36:05.216Z')
      },
      {
        fullValue: 596,
        timestamp: new Date('2017-06-06T18:16:01.274Z')
      },
      {
        fullValue: 595,
        timestamp: new Date('2017-06-06T17:55:57.416Z')
      },
      {
        fullValue: 585,
        timestamp: new Date('2017-06-06T17:35:53.714Z')
      },
      {
        fullValue: 592,
        timestamp: new Date('2017-06-06T17:15:50.318Z')
      },
      {
        fullValue: 601,
        timestamp: new Date('2017-06-06T16:55:46.419Z')
      },
      {
        fullValue: 600,
        timestamp: new Date('2017-06-06T16:35:42.753Z')
      },
      {
        fullValue: 597,
        timestamp: new Date('2017-06-06T16:15:39.570Z')
      },
      {
        fullValue: 608,
        timestamp: new Date('2017-06-06T15:55:33.686Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-06T15:35:31.019Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-06T15:15:26.108Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-06T14:55:21.007Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-06T14:35:16.251Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-06T14:15:10.664Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-06T13:55:06.687Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-06T13:35:03.110Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-06T13:14:58.222Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-06T12:54:53.537Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-06T12:34:47.222Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-06T12:14:42.788Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-06T11:54:37.788Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-06T11:34:33.374Z')
      },
      {
        fullValue: 642,
        timestamp: new Date('2017-06-06T11:14:29.245Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-06T10:54:24.922Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-06T10:34:20.412Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-06T10:14:15.728Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-06T09:54:10.068Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-06T09:34:06.560Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-06T09:14:01.652Z')
      },
      {
        fullValue: 641,
        timestamp: new Date('2017-06-06T08:53:58.096Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-06T08:33:53.339Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-06T08:13:49.070Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-06T07:53:45.356Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-06T07:33:41.461Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-06T07:13:36.406Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-06T06:53:32.487Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-06T06:33:27.630Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-06T06:13:23.912Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-06T05:53:17.816Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-06T05:33:13.185Z')
      },
      {
        fullValue: 642,
        timestamp: new Date('2017-06-06T05:13:09.278Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-06T04:53:04.808Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-06T04:32:59.029Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-06T04:12:55.262Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-06T03:52:50.798Z')
      },
      {
        fullValue: 645,
        timestamp: new Date('2017-06-06T03:32:46.881Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-06T03:12:43.013Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-06T02:52:40.229Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-06T02:32:36.279Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-06T02:12:32.513Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-06T01:52:29.684Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-06T01:32:26.115Z')
      }
    ],
    error: null
  },
  2015: {
    isFetching: false,
    data: [
      {
        fullValue: 641,
        timestamp: new Date('2017-06-13T01:22:34.486Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-13T01:02:30.399Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-13T00:42:25.241Z')
      },
      {
        fullValue: 638,
        timestamp: new Date('2017-06-13T00:22:19.292Z')
      },
      {
        fullValue: 634,
        timestamp: new Date('2017-06-13T00:02:13.542Z')
      },
      {
        fullValue: 603,
        timestamp: new Date('2017-06-12T23:42:08.097Z')
      },
      {
        fullValue: 615,
        timestamp: new Date('2017-06-12T23:22:02.582Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-12T23:01:57.519Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-12T22:41:51.393Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-12T22:21:45.786Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-12T22:01:40.867Z')
      },
      {
        fullValue: 711,
        timestamp: new Date('2017-06-12T21:41:35.988Z')
      },
      {
        fullValue: 607,
        timestamp: new Date('2017-06-12T21:22:30.953Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-12T21:02:25.546Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-12T20:42:19.458Z')
      },
      {
        fullValue: 615,
        timestamp: new Date('2017-06-12T20:22:13.866Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-12T20:02:08.605Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-12T19:42:03.592Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-12T19:21:58.041Z')
      },
      {
        fullValue: 628,
        timestamp: new Date('2017-06-12T19:01:52.903Z')
      },
      {
        fullValue: 629,
        timestamp: new Date('2017-06-12T18:40:47.527Z')
      },
      {
        fullValue: 662,
        timestamp: new Date('2017-06-12T18:20:43.121Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-12T18:00:37.995Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-12T17:40:32.687Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-12T17:19:30.102Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-12T16:59:26.542Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-12T16:39:23.602Z')
      },
      {
        fullValue: 665,
        timestamp: new Date('2017-06-12T16:19:20.513Z')
      },
      {
        fullValue: 672,
        timestamp: new Date('2017-06-12T15:59:18.326Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-12T15:39:13.706Z')
      },
      {
        fullValue: 699,
        timestamp: new Date('2017-06-12T15:19:09.141Z')
      },
      {
        fullValue: 704,
        timestamp: new Date('2017-06-12T14:59:05.203Z')
      },
      {
        fullValue: 701,
        timestamp: new Date('2017-06-12T14:39:01.745Z')
      },
      {
        fullValue: 721,
        timestamp: new Date('2017-06-12T14:18:57.461Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-12T13:48:25.332Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-12T13:28:20.504Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-12T13:08:15.511Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-12T12:48:09.913Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-12T12:28:04.439Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-12T12:07:58.829Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-12T11:47:53.837Z')
      },
      {
        fullValue: 600,
        timestamp: new Date('2017-06-12T11:27:50.415Z')
      },
      {
        fullValue: 604,
        timestamp: new Date('2017-06-12T11:07:45.886Z')
      },
      {
        fullValue: 608,
        timestamp: new Date('2017-06-12T10:47:42.427Z')
      },
      {
        fullValue: 617,
        timestamp: new Date('2017-06-12T10:27:38.659Z')
      },
      {
        fullValue: 625,
        timestamp: new Date('2017-06-12T10:07:33.679Z')
      },
      {
        fullValue: 634,
        timestamp: new Date('2017-06-12T09:47:30.063Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-12T09:27:26.110Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-12T09:07:21.945Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-12T08:47:16.650Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-12T08:27:10.816Z')
      },
      {
        fullValue: 676,
        timestamp: new Date('2017-06-12T08:07:03.195Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-12T07:46:55.675Z')
      },
      {
        fullValue: 642,
        timestamp: new Date('2017-06-12T07:26:50.958Z')
      },
      {
        fullValue: 660,
        timestamp: new Date('2017-06-12T07:06:44.440Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-12T06:46:39.890Z')
      },
      {
        fullValue: 683,
        timestamp: new Date('2017-06-12T06:26:32.273Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-12T06:06:24.993Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-12T05:46:19.744Z')
      },
      {
        fullValue: 675,
        timestamp: new Date('2017-06-12T05:26:13.005Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-12T05:06:06.877Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-12T04:46:01.715Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-12T04:25:54.080Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-12T04:05:49.625Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-12T03:45:43.248Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-12T03:25:37.723Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-12T03:05:33.285Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-12T02:45:26.656Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-12T02:25:20.089Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-12T02:05:15.304Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-12T01:45:10.525Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-12T01:25:03.464Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-12T01:04:57.319Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-12T00:44:53.267Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-12T00:24:47.662Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-12T00:04:40.788Z')
      },
      {
        fullValue: 676,
        timestamp: new Date('2017-06-11T23:44:35.687Z')
      },
      {
        fullValue: 675,
        timestamp: new Date('2017-06-11T23:24:32.971Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-11T23:04:28.558Z')
      },
      {
        fullValue: 671,
        timestamp: new Date('2017-06-11T22:43:25.031Z')
      },
      {
        fullValue: 677,
        timestamp: new Date('2017-06-11T22:23:21.693Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-11T22:03:19.272Z')
      },
      {
        fullValue: 766,
        timestamp: new Date('2017-06-11T21:43:14.756Z')
      },
      {
        fullValue: 674,
        timestamp: new Date('2017-06-11T21:23:08.598Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-11T21:03:02.303Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-11T20:42:55.640Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-11T20:22:49.469Z')
      },
      {
        fullValue: 660,
        timestamp: new Date('2017-06-11T20:02:43.002Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-11T19:42:36.420Z')
      },
      {
        fullValue: 639,
        timestamp: new Date('2017-06-11T19:22:30.814Z')
      },
      {
        fullValue: 688,
        timestamp: new Date('2017-06-11T19:02:25.240Z')
      },
      {
        fullValue: 664,
        timestamp: new Date('2017-06-11T18:42:18.755Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-11T18:22:12.440Z')
      },
      {
        fullValue: 691,
        timestamp: new Date('2017-06-11T18:02:06.142Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-11T17:41:59.328Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-11T17:21:52.997Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-11T17:01:46.849Z')
      },
      {
        fullValue: 710,
        timestamp: new Date('2017-06-11T16:41:40.353Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-11T16:21:34.165Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-11T16:01:27.401Z')
      },
      {
        fullValue: 668,
        timestamp: new Date('2017-06-11T15:41:21.077Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-11T15:20:14.502Z')
      },
      {
        fullValue: 672,
        timestamp: new Date('2017-06-11T15:00:09.038Z')
      },
      {
        fullValue: 669,
        timestamp: new Date('2017-06-11T14:40:04.389Z')
      },
      {
        fullValue: 669,
        timestamp: new Date('2017-06-11T14:19:57.876Z')
      },
      {
        fullValue: 660,
        timestamp: new Date('2017-06-11T13:59:52.105Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-11T13:39:46.050Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-11T13:19:38.963Z')
      },
      {
        fullValue: 626,
        timestamp: new Date('2017-06-11T12:59:34.380Z')
      },
      {
        fullValue: 594,
        timestamp: new Date('2017-06-11T12:39:29.055Z')
      },
      {
        fullValue: 605,
        timestamp: new Date('2017-06-11T12:19:23.457Z')
      },
      {
        fullValue: 630,
        timestamp: new Date('2017-06-11T11:59:17.063Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-11T11:39:11.185Z')
      },
      {
        fullValue: 623,
        timestamp: new Date('2017-06-11T11:19:04.809Z')
      },
      {
        fullValue: 636,
        timestamp: new Date('2017-06-11T10:59:00.491Z')
      },
      {
        fullValue: 668,
        timestamp: new Date('2017-06-11T10:38:54.763Z')
      },
      {
        fullValue: 664,
        timestamp: new Date('2017-06-11T10:18:49.161Z')
      },
      {
        fullValue: 660,
        timestamp: new Date('2017-06-11T09:58:41.666Z')
      },
      {
        fullValue: 658,
        timestamp: new Date('2017-06-11T09:38:35.997Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-11T09:18:29.889Z')
      },
      {
        fullValue: 615,
        timestamp: new Date('2017-06-11T08:58:23.985Z')
      },
      {
        fullValue: 594,
        timestamp: new Date('2017-06-11T08:38:17.749Z')
      },
      {
        fullValue: 604,
        timestamp: new Date('2017-06-11T08:18:10.987Z')
      },
      {
        fullValue: 636,
        timestamp: new Date('2017-06-11T07:58:04.981Z')
      },
      {
        fullValue: 614,
        timestamp: new Date('2017-06-11T07:37:59.032Z')
      },
      {
        fullValue: 618,
        timestamp: new Date('2017-06-11T07:17:52.183Z')
      },
      {
        fullValue: 630,
        timestamp: new Date('2017-06-11T06:57:46.038Z')
      },
      {
        fullValue: 659,
        timestamp: new Date('2017-06-11T06:37:39.889Z')
      },
      {
        fullValue: 663,
        timestamp: new Date('2017-06-11T06:17:32.934Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-11T05:57:25.258Z')
      },
      {
        fullValue: 660,
        timestamp: new Date('2017-06-11T05:37:20.534Z')
      },
      {
        fullValue: 669,
        timestamp: new Date('2017-06-11T05:17:13.490Z')
      },
      {
        fullValue: 663,
        timestamp: new Date('2017-06-11T04:57:07.427Z')
      },
      {
        fullValue: 608,
        timestamp: new Date('2017-06-11T04:37:01.915Z')
      },
      {
        fullValue: 614,
        timestamp: new Date('2017-06-11T04:16:56.085Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-11T03:56:49.226Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-11T03:36:43.325Z')
      },
      {
        fullValue: 663,
        timestamp: new Date('2017-06-11T03:16:38.581Z')
      },
      {
        fullValue: 663,
        timestamp: new Date('2017-06-11T02:56:31.843Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-11T02:36:26.322Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-11T02:16:20.799Z')
      },
      {
        fullValue: 598,
        timestamp: new Date('2017-06-11T01:56:14.639Z')
      },
      {
        fullValue: 594,
        timestamp: new Date('2017-06-11T01:36:08.695Z')
      },
      {
        fullValue: 602,
        timestamp: new Date('2017-06-11T01:16:02.467Z')
      },
      {
        fullValue: 607,
        timestamp: new Date('2017-06-11T00:55:56.489Z')
      },
      {
        fullValue: 611,
        timestamp: new Date('2017-06-11T00:35:50.394Z')
      },
      {
        fullValue: 616,
        timestamp: new Date('2017-06-11T00:15:43.771Z')
      },
      {
        fullValue: 622,
        timestamp: new Date('2017-06-10T23:55:38.064Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-10T23:35:31.364Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-10T23:15:25.391Z')
      },
      {
        fullValue: 675,
        timestamp: new Date('2017-06-10T22:55:19.197Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-10T22:35:14.135Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-10T22:15:06.865Z')
      },
      {
        fullValue: 764,
        timestamp: new Date('2017-06-10T21:55:01.013Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-10T21:34:55.047Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-10T21:14:51.338Z')
      },
      {
        fullValue: 677,
        timestamp: new Date('2017-06-10T20:54:48.647Z')
      },
      {
        fullValue: 664,
        timestamp: new Date('2017-06-10T20:34:45.928Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-10T20:14:43.451Z')
      },
      {
        fullValue: 641,
        timestamp: new Date('2017-06-10T19:54:41.019Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T19:34:37.936Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-10T19:14:35.196Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-10T18:54:31.643Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-10T18:34:26.074Z')
      },
      {
        fullValue: 664,
        timestamp: new Date('2017-06-10T18:14:23.590Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-10T17:54:20.002Z')
      },
      {
        fullValue: 662,
        timestamp: new Date('2017-06-10T17:34:16.297Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-10T17:14:13.462Z')
      },
      {
        fullValue: 698,
        timestamp: new Date('2017-06-10T16:54:09.955Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-10T16:34:06.340Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-10T16:14:03.529Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-10T15:54:01.017Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-10T15:33:58.180Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-10T15:13:51.796Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-10T14:53:45.278Z')
      },
      {
        fullValue: 589,
        timestamp: new Date('2017-06-10T14:33:40.857Z')
      },
      {
        fullValue: 595,
        timestamp: new Date('2017-06-10T14:13:35.002Z')
      },
      {
        fullValue: 601,
        timestamp: new Date('2017-06-10T13:53:28.680Z')
      },
      {
        fullValue: 610,
        timestamp: new Date('2017-06-10T13:33:23.024Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-10T13:13:17.763Z')
      },
      {
        fullValue: 669,
        timestamp: new Date('2017-06-10T12:53:10.829Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-10T12:33:05.334Z')
      },
      {
        fullValue: 671,
        timestamp: new Date('2017-06-10T12:12:59.099Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-10T11:52:53.880Z')
      },
      {
        fullValue: 665,
        timestamp: new Date('2017-06-10T11:32:46.723Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-10T11:12:38.811Z')
      },
      {
        fullValue: 600,
        timestamp: new Date('2017-06-10T10:52:34.295Z')
      },
      {
        fullValue: 604,
        timestamp: new Date('2017-06-10T10:32:29.365Z')
      },
      {
        fullValue: 638,
        timestamp: new Date('2017-06-10T10:12:25.012Z')
      },
      {
        fullValue: 609,
        timestamp: new Date('2017-06-10T09:52:18.187Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-10T09:31:13.190Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-10T09:11:06.647Z')
      },
      {
        fullValue: 626,
        timestamp: new Date('2017-06-10T08:51:00.312Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-10T08:30:54.964Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-10T08:10:48.904Z')
      },
      {
        fullValue: 673,
        timestamp: new Date('2017-06-10T07:50:42.167Z')
      },
      {
        fullValue: 671,
        timestamp: new Date('2017-06-10T07:30:34.361Z')
      },
      {
        fullValue: 669,
        timestamp: new Date('2017-06-10T07:10:27.811Z')
      },
      {
        fullValue: 668,
        timestamp: new Date('2017-06-10T06:50:24.248Z')
      },
      {
        fullValue: 675,
        timestamp: new Date('2017-06-10T06:30:21.703Z')
      },
      {
        fullValue: 603,
        timestamp: new Date('2017-06-10T06:10:17.041Z')
      },
      {
        fullValue: 608,
        timestamp: new Date('2017-06-10T05:50:10.123Z')
      },
      {
        fullValue: 621,
        timestamp: new Date('2017-06-10T05:30:04.628Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-10T05:09:59.723Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-10T04:49:56.027Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-10T04:29:52.873Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-10T04:09:49.180Z')
      },
      {
        fullValue: 693,
        timestamp: new Date('2017-06-10T03:49:45.562Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-10T03:29:42.492Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-10T03:09:38.925Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-10T02:49:32.408Z')
      },
      {
        fullValue: 672,
        timestamp: new Date('2017-06-10T02:29:26.543Z')
      },
      {
        fullValue: 667,
        timestamp: new Date('2017-06-10T02:09:21.743Z')
      },
      {
        fullValue: 624,
        timestamp: new Date('2017-06-10T01:49:15.450Z')
      },
      {
        fullValue: 672,
        timestamp: new Date('2017-06-10T01:29:11.875Z')
      },
      {
        fullValue: 605,
        timestamp: new Date('2017-06-10T01:09:07.968Z')
      },
      {
        fullValue: 609,
        timestamp: new Date('2017-06-10T00:49:10.033Z')
      },
      {
        fullValue: 614,
        timestamp: new Date('2017-06-10T00:30:24.943Z')
      },
      {
        fullValue: 624,
        timestamp: new Date('2017-06-10T00:12:17.509Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-09T23:51:54.672Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-09T23:31:48.108Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-09T23:11:42.825Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-09T22:50:37.333Z')
      },
      {
        fullValue: 671,
        timestamp: new Date('2017-06-09T22:30:31.551Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-09T22:10:25.398Z')
      },
      {
        fullValue: 741,
        timestamp: new Date('2017-06-09T21:46:56.125Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-09T21:26:50.226Z')
      },
      {
        fullValue: 683,
        timestamp: new Date('2017-06-09T21:06:44.526Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-09T20:46:38.811Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-09T20:26:32.895Z')
      },
      {
        fullValue: 639,
        timestamp: new Date('2017-06-09T20:06:26.043Z')
      },
      {
        fullValue: 636,
        timestamp: new Date('2017-06-09T19:46:19.739Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-09T19:26:14.781Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-09T19:06:10.429Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-09T18:46:05.832Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-09T18:26:00.164Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-09T18:05:53.626Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-09T17:45:48.057Z')
      },
      {
        fullValue: 637,
        timestamp: new Date('2017-06-09T17:25:41.379Z')
      },
      {
        fullValue: 688,
        timestamp: new Date('2017-06-09T17:05:34.693Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-09T16:45:27.966Z')
      },
      {
        fullValue: 637,
        timestamp: new Date('2017-06-09T16:25:21.118Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-09T16:05:14.670Z')
      },
      {
        fullValue: 639,
        timestamp: new Date('2017-06-09T15:45:11.086Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-09T15:25:06.615Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-09T15:05:01.727Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-09T14:45:57.694Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-09T14:25:52.095Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-09T14:05:44.667Z')
      },
      {
        fullValue: 684,
        timestamp: new Date('2017-06-09T13:45:38.046Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-09T13:25:32.434Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-09T13:05:26.166Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-09T12:45:19.023Z')
      },
      {
        fullValue: 662,
        timestamp: new Date('2017-06-09T12:25:13.461Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-09T12:05:08.633Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-09T11:45:00.823Z')
      },
      {
        fullValue: 675,
        timestamp: new Date('2017-06-09T11:24:53.679Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-09T11:04:48.919Z')
      },
      {
        fullValue: 673,
        timestamp: new Date('2017-06-09T10:44:41.192Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-09T10:24:35.084Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-09T10:04:28.542Z')
      },
      {
        fullValue: 676,
        timestamp: new Date('2017-06-09T09:44:23.283Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-09T09:24:15.566Z')
      },
      {
        fullValue: 665,
        timestamp: new Date('2017-06-09T09:04:08.046Z')
      },
      {
        fullValue: 703,
        timestamp: new Date('2017-06-09T08:44:02.279Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-09T08:23:55.619Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-09T08:03:47.942Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-09T07:43:42.753Z')
      },
      {
        fullValue: 669,
        timestamp: new Date('2017-06-09T07:23:35.105Z')
      },
      {
        fullValue: 676,
        timestamp: new Date('2017-06-09T07:03:29.098Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-09T06:43:23.004Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-09T06:23:17.353Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-09T06:03:09.789Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-09T05:43:02.100Z')
      },
      {
        fullValue: 678,
        timestamp: new Date('2017-06-09T05:22:57.075Z')
      },
      {
        fullValue: 613,
        timestamp: new Date('2017-06-09T05:02:51.157Z')
      },
      {
        fullValue: 663,
        timestamp: new Date('2017-06-09T04:42:44.901Z')
      },
      {
        fullValue: 637,
        timestamp: new Date('2017-06-09T04:22:38.561Z')
      },
      {
        fullValue: 668,
        timestamp: new Date('2017-06-09T04:02:34.037Z')
      },
      {
        fullValue: 707,
        timestamp: new Date('2017-06-09T03:42:27.307Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-09T03:22:19.639Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-09T03:02:13.069Z')
      },
      {
        fullValue: 630,
        timestamp: new Date('2017-06-09T02:42:08.660Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-09T02:22:02.693Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-09T02:01:57.061Z')
      },
      {
        fullValue: 668,
        timestamp: new Date('2017-06-09T01:41:50.541Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-09T01:21:43.421Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-09T01:01:35.927Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-09T00:41:28.761Z')
      },
      {
        fullValue: 634,
        timestamp: new Date('2017-06-09T00:21:23.873Z')
      },
      {
        fullValue: 607,
        timestamp: new Date('2017-06-09T00:01:17.408Z')
      },
      {
        fullValue: 645,
        timestamp: new Date('2017-06-08T23:41:11.386Z')
      },
      {
        fullValue: 632,
        timestamp: new Date('2017-06-08T23:21:06.227Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-08T23:01:01.330Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-08T22:40:53.517Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-08T22:20:46.266Z')
      },
      {
        fullValue: 781,
        timestamp: new Date('2017-06-08T22:00:40.642Z')
      },
      {
        fullValue: 746,
        timestamp: new Date('2017-06-08T21:40:34.607Z')
      },
      {
        fullValue: 687,
        timestamp: new Date('2017-06-08T21:20:30.134Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-08T21:00:26.398Z')
      },
      {
        fullValue: 667,
        timestamp: new Date('2017-06-08T20:40:20.971Z')
      },
      {
        fullValue: 664,
        timestamp: new Date('2017-06-08T20:20:14.408Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-08T20:00:09.018Z')
      },
      {
        fullValue: 659,
        timestamp: new Date('2017-06-08T19:40:02.506Z')
      },
      {
        fullValue: 653,
        timestamp: new Date('2017-06-08T19:19:55.993Z')
      },
      {
        fullValue: 645,
        timestamp: new Date('2017-06-08T18:59:50.834Z')
      },
      {
        fullValue: 645,
        timestamp: new Date('2017-06-08T18:39:47.601Z')
      },
      {
        fullValue: 635,
        timestamp: new Date('2017-06-08T18:19:45.157Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-08T17:59:42.089Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-08T17:40:38.334Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-08T17:20:33.287Z')
      },
      {
        fullValue: 640,
        timestamp: new Date('2017-06-08T17:00:29.717Z')
      },
      {
        fullValue: 623,
        timestamp: new Date('2017-06-08T16:40:25.950Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-08T16:20:23.259Z')
      },
      {
        fullValue: 617,
        timestamp: new Date('2017-06-08T16:00:20.582Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-08T15:40:17.831Z')
      },
      {
        fullValue: 615,
        timestamp: new Date('2017-06-08T15:20:14.953Z')
      },
      {
        fullValue: 594,
        timestamp: new Date('2017-06-08T15:00:08.565Z')
      },
      {
        fullValue: 586,
        timestamp: new Date('2017-06-08T14:40:03.127Z')
      },
      {
        fullValue: 574,
        timestamp: new Date('2017-06-08T14:19:57.347Z')
      },
      {
        fullValue: 584,
        timestamp: new Date('2017-06-08T13:59:51.132Z')
      },
      {
        fullValue: 602,
        timestamp: new Date('2017-06-08T13:39:45.549Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-08T13:19:39.570Z')
      },
      {
        fullValue: 606,
        timestamp: new Date('2017-06-08T12:59:33.222Z')
      },
      {
        fullValue: 634,
        timestamp: new Date('2017-06-08T12:39:27.480Z')
      },
      {
        fullValue: 674,
        timestamp: new Date('2017-06-08T12:19:20.651Z')
      },
      {
        fullValue: 642,
        timestamp: new Date('2017-06-08T11:59:14.911Z')
      },
      {
        fullValue: 641,
        timestamp: new Date('2017-06-08T11:39:07.982Z')
      },
      {
        fullValue: 645,
        timestamp: new Date('2017-06-08T11:19:01.178Z')
      },
      {
        fullValue: 634,
        timestamp: new Date('2017-06-08T10:58:55.017Z')
      },
      {
        fullValue: 590,
        timestamp: new Date('2017-06-08T10:38:49.539Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-08T10:18:44.040Z')
      },
      {
        fullValue: 613,
        timestamp: new Date('2017-06-08T09:57:37.272Z')
      },
      {
        fullValue: 591,
        timestamp: new Date('2017-06-08T09:37:31.661Z')
      },
      {
        fullValue: 623,
        timestamp: new Date('2017-06-08T09:17:26.112Z')
      },
      {
        fullValue: 602,
        timestamp: new Date('2017-06-08T08:57:21.079Z')
      },
      {
        fullValue: 634,
        timestamp: new Date('2017-06-08T08:37:14.706Z')
      },
      {
        fullValue: 637,
        timestamp: new Date('2017-06-08T08:17:08.624Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-08T07:57:02.953Z')
      },
      {
        fullValue: 685,
        timestamp: new Date('2017-06-08T07:35:57.466Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-08T07:13:49.854Z')
      },
      {
        fullValue: 644,
        timestamp: new Date('2017-06-08T06:53:42.776Z')
      },
      {
        fullValue: 624,
        timestamp: new Date('2017-06-08T06:33:38.198Z')
      },
      {
        fullValue: 578,
        timestamp: new Date('2017-06-08T06:11:31.186Z')
      },
      {
        fullValue: 625,
        timestamp: new Date('2017-06-08T05:51:25.594Z')
      },
      {
        fullValue: 588,
        timestamp: new Date('2017-06-08T05:31:19.499Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-08T05:11:13.733Z')
      },
      {
        fullValue: 597,
        timestamp: new Date('2017-06-08T04:51:07.615Z')
      },
      {
        fullValue: 637,
        timestamp: new Date('2017-06-08T04:31:02.004Z')
      },
      {
        fullValue: 614,
        timestamp: new Date('2017-06-08T04:06:54.115Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-08T03:46:48.377Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-08T03:26:42.565Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-08T03:06:36.667Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-08T02:46:30.808Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-08T02:26:23.735Z')
      },
      {
        fullValue: 651,
        timestamp: new Date('2017-06-08T02:06:16.685Z')
      },
      {
        fullValue: 571,
        timestamp: new Date('2017-06-08T01:46:09.705Z')
      },
      {
        fullValue: 603,
        timestamp: new Date('2017-06-08T01:26:04.166Z')
      },
      {
        fullValue: 580,
        timestamp: new Date('2017-06-08T01:05:57.971Z')
      },
      {
        fullValue: 598,
        timestamp: new Date('2017-06-08T00:45:53.217Z')
      },
      {
        fullValue: 647,
        timestamp: new Date('2017-06-08T00:25:46.893Z')
      },
      {
        fullValue: 601,
        timestamp: new Date('2017-06-08T00:05:41.403Z')
      },
      {
        fullValue: 622,
        timestamp: new Date('2017-06-07T23:45:35.988Z')
      },
      {
        fullValue: 671,
        timestamp: new Date('2017-06-07T23:25:29.483Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-07T23:05:23.837Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-07T22:45:16.894Z')
      },
      {
        fullValue: 672,
        timestamp: new Date('2017-06-07T22:25:09.773Z')
      },
      {
        fullValue: 731,
        timestamp: new Date('2017-06-07T22:05:02.650Z')
      },
      {
        fullValue: 785,
        timestamp: new Date('2017-06-07T21:44:55.767Z')
      },
      {
        fullValue: 646,
        timestamp: new Date('2017-06-07T21:24:50.155Z')
      },
      {
        fullValue: 654,
        timestamp: new Date('2017-06-07T21:04:45.711Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-07T20:44:41.889Z')
      },
      {
        fullValue: 673,
        timestamp: new Date('2017-06-07T20:24:36.581Z')
      },
      {
        fullValue: 679,
        timestamp: new Date('2017-06-07T20:04:32.331Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-07T19:44:30.353Z')
      },
      {
        fullValue: 681,
        timestamp: new Date('2017-06-07T19:20:53.206Z')
      },
      {
        fullValue: 670,
        timestamp: new Date('2017-06-07T19:00:48.916Z')
      },
      {
        fullValue: 664,
        timestamp: new Date('2017-06-07T18:38:51.621Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-07T18:15:14.418Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-07T17:53:10.469Z')
      },
      {
        fullValue: 632,
        timestamp: new Date('2017-06-07T17:33:04.474Z')
      },
      {
        fullValue: 675,
        timestamp: new Date('2017-06-07T17:13:00.618Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-07T16:51:55.500Z')
      },
      {
        fullValue: 649,
        timestamp: new Date('2017-06-07T16:31:51.477Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-07T16:06:24.878Z')
      },
      {
        fullValue: 562,
        timestamp: new Date('2017-06-07T15:46:19.704Z')
      },
      {
        fullValue: 572,
        timestamp: new Date('2017-06-07T15:27:14.182Z')
      },
      {
        fullValue: 561,
        timestamp: new Date('2017-06-07T15:07:09.454Z')
      },
      {
        fullValue: 570,
        timestamp: new Date('2017-06-07T14:47:03.892Z')
      },
      {
        fullValue: 590,
        timestamp: new Date('2017-06-07T14:26:58.106Z')
      },
      {
        fullValue: 716,
        timestamp: new Date('2017-06-07T14:06:51.765Z')
      },
      {
        fullValue: 582,
        timestamp: new Date('2017-06-07T13:46:47.495Z')
      },
      {
        fullValue: 591,
        timestamp: new Date('2017-06-07T13:26:41.270Z')
      },
      {
        fullValue: 604,
        timestamp: new Date('2017-06-07T13:06:35.232Z')
      },
      {
        fullValue: 580,
        timestamp: new Date('2017-06-07T12:46:29.429Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-07T12:26:23.561Z')
      },
      {
        fullValue: 604,
        timestamp: new Date('2017-06-07T12:06:19.449Z')
      },
      {
        fullValue: 587,
        timestamp: new Date('2017-06-07T11:46:13.167Z')
      },
      {
        fullValue: 658,
        timestamp: new Date('2017-06-07T11:26:07.078Z')
      },
      {
        fullValue: 611,
        timestamp: new Date('2017-06-07T11:06:00.597Z')
      },
      {
        fullValue: 594,
        timestamp: new Date('2017-06-07T10:45:55.351Z')
      },
      {
        fullValue: 588,
        timestamp: new Date('2017-06-07T10:25:50.697Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-07T10:05:44.763Z')
      },
      {
        fullValue: 603,
        timestamp: new Date('2017-06-07T09:45:38.847Z')
      },
      {
        fullValue: 588,
        timestamp: new Date('2017-06-07T09:25:32.338Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-07T09:05:26.946Z')
      },
      {
        fullValue: 612,
        timestamp: new Date('2017-06-07T08:45:20.936Z')
      },
      {
        fullValue: 596,
        timestamp: new Date('2017-06-07T08:25:15.544Z')
      },
      {
        fullValue: 667,
        timestamp: new Date('2017-06-07T08:05:10.716Z')
      },
      {
        fullValue: 624,
        timestamp: new Date('2017-06-07T07:45:05.325Z')
      },
      {
        fullValue: 604,
        timestamp: new Date('2017-06-07T07:24:59.847Z')
      },
      {
        fullValue: 635,
        timestamp: new Date('2017-06-07T07:04:53.517Z')
      },
      {
        fullValue: 652,
        timestamp: new Date('2017-06-07T06:44:49.574Z')
      },
      {
        fullValue: 619,
        timestamp: new Date('2017-06-07T06:24:43.934Z')
      },
      {
        fullValue: 605,
        timestamp: new Date('2017-06-07T06:04:37.950Z')
      },
      {
        fullValue: 708,
        timestamp: new Date('2017-06-07T05:44:31.647Z')
      },
      {
        fullValue: 632,
        timestamp: new Date('2017-06-07T05:24:27.955Z')
      },
      {
        fullValue: 615,
        timestamp: new Date('2017-06-07T05:04:22.058Z')
      },
      {
        fullValue: 650,
        timestamp: new Date('2017-06-07T04:44:16.285Z')
      },
      {
        fullValue: 673,
        timestamp: new Date('2017-06-07T04:24:11.453Z')
      },
      {
        fullValue: 639,
        timestamp: new Date('2017-06-07T04:03:05.778Z')
      },
      {
        fullValue: 624,
        timestamp: new Date('2017-06-07T03:43:00.049Z')
      },
      {
        fullValue: 617,
        timestamp: new Date('2017-06-07T03:21:53.316Z')
      },
      {
        fullValue: 716,
        timestamp: new Date('2017-06-07T03:01:49.578Z')
      },
      {
        fullValue: 656,
        timestamp: new Date('2017-06-07T02:41:43.588Z')
      },
      {
        fullValue: 637,
        timestamp: new Date('2017-06-07T02:21:37.957Z')
      },
      {
        fullValue: 631,
        timestamp: new Date('2017-06-07T02:01:32.651Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-07T01:41:26.939Z')
      },
      {
        fullValue: 709,
        timestamp: new Date('2017-06-07T01:21:21.722Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-07T01:01:15.819Z')
      },
      {
        fullValue: 666,
        timestamp: new Date('2017-06-07T00:41:10.351Z')
      },
      {
        fullValue: 662,
        timestamp: new Date('2017-06-07T00:21:05.146Z')
      },
      {
        fullValue: 659,
        timestamp: new Date('2017-06-07T00:00:59.540Z')
      },
      {
        fullValue: 669,
        timestamp: new Date('2017-06-06T23:40:54.586Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-06T23:20:49.233Z')
      },
      {
        fullValue: 751,
        timestamp: new Date('2017-06-06T23:00:44.183Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-06T22:40:39.485Z')
      },
      {
        fullValue: 680,
        timestamp: new Date('2017-06-06T22:20:33.611Z')
      },
      {
        fullValue: 720,
        timestamp: new Date('2017-06-06T22:00:28.379Z')
      },
      {
        fullValue: 673,
        timestamp: new Date('2017-06-06T21:40:22.546Z')
      },
      {
        fullValue: 716,
        timestamp: new Date('2017-06-06T21:20:18.381Z')
      },
      {
        fullValue: 688,
        timestamp: new Date('2017-06-06T21:00:14.421Z')
      },
      {
        fullValue: 721,
        timestamp: new Date('2017-06-06T20:40:10.602Z')
      },
      {
        fullValue: 690,
        timestamp: new Date('2017-06-06T20:20:06.729Z')
      },
      {
        fullValue: 729,
        timestamp: new Date('2017-06-06T20:00:02.707Z')
      },
      {
        fullValue: 692,
        timestamp: new Date('2017-06-06T19:39:59.578Z')
      },
      {
        fullValue: 748,
        timestamp: new Date('2017-06-06T19:16:13.106Z')
      },
      {
        fullValue: 717,
        timestamp: new Date('2017-06-06T18:56:09.087Z')
      },
      {
        fullValue: 766,
        timestamp: new Date('2017-06-06T18:36:05.216Z')
      },
      {
        fullValue: 717,
        timestamp: new Date('2017-06-06T18:16:01.274Z')
      },
      {
        fullValue: 767,
        timestamp: new Date('2017-06-06T17:55:57.416Z')
      },
      {
        fullValue: 736,
        timestamp: new Date('2017-06-06T17:35:53.714Z')
      },
      {
        fullValue: 716,
        timestamp: new Date('2017-06-06T17:15:50.318Z')
      },
      {
        fullValue: 765,
        timestamp: new Date('2017-06-06T16:55:46.419Z')
      },
      {
        fullValue: 811,
        timestamp: new Date('2017-06-06T16:35:42.753Z')
      },
      {
        fullValue: 821,
        timestamp: new Date('2017-06-06T16:15:39.570Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-06T15:55:33.686Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-06T15:35:31.019Z')
      },
      {
        fullValue: 719,
        timestamp: new Date('2017-06-06T15:15:26.108Z')
      },
      {
        fullValue: 677,
        timestamp: new Date('2017-06-06T14:55:21.007Z')
      },
      {
        fullValue: 697,
        timestamp: new Date('2017-06-06T14:35:16.251Z')
      },
      {
        fullValue: 700,
        timestamp: new Date('2017-06-06T14:15:10.664Z')
      },
      {
        fullValue: 655,
        timestamp: new Date('2017-06-06T13:55:06.687Z')
      },
      {
        fullValue: 638,
        timestamp: new Date('2017-06-06T13:35:03.110Z')
      },
      {
        fullValue: 621,
        timestamp: new Date('2017-06-06T13:14:58.222Z')
      },
      {
        fullValue: 710,
        timestamp: new Date('2017-06-06T12:54:53.537Z')
      },
      {
        fullValue: 582,
        timestamp: new Date('2017-06-06T12:34:47.222Z')
      },
      {
        fullValue: 625,
        timestamp: new Date('2017-06-06T12:14:42.788Z')
      },
      {
        fullValue: 582,
        timestamp: new Date('2017-06-06T11:54:37.788Z')
      },
      {
        fullValue: 643,
        timestamp: new Date('2017-06-06T11:34:33.374Z')
      },
      {
        fullValue: 600,
        timestamp: new Date('2017-06-06T11:14:29.245Z')
      },
      {
        fullValue: 623,
        timestamp: new Date('2017-06-06T10:54:24.922Z')
      },
      {
        fullValue: 585,
        timestamp: new Date('2017-06-06T10:34:20.412Z')
      },
      {
        fullValue: 633,
        timestamp: new Date('2017-06-06T10:14:15.728Z')
      },
      {
        fullValue: 658,
        timestamp: new Date('2017-06-06T09:54:10.068Z')
      },
      {
        fullValue: 607,
        timestamp: new Date('2017-06-06T09:34:06.560Z')
      },
      {
        fullValue: 686,
        timestamp: new Date('2017-06-06T09:14:01.652Z')
      },
      {
        fullValue: 591,
        timestamp: new Date('2017-06-06T08:53:58.096Z')
      },
      {
        fullValue: 626,
        timestamp: new Date('2017-06-06T08:33:53.339Z')
      },
      {
        fullValue: 721,
        timestamp: new Date('2017-06-06T08:13:49.070Z')
      },
      {
        fullValue: 598,
        timestamp: new Date('2017-06-06T07:53:45.356Z')
      },
      {
        fullValue: 648,
        timestamp: new Date('2017-06-06T07:33:41.461Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-06T07:13:36.406Z')
      },
      {
        fullValue: 611,
        timestamp: new Date('2017-06-06T06:53:32.487Z')
      },
      {
        fullValue: 682,
        timestamp: new Date('2017-06-06T06:33:27.630Z')
      },
      {
        fullValue: 602,
        timestamp: new Date('2017-06-06T06:13:23.912Z')
      },
      {
        fullValue: 627,
        timestamp: new Date('2017-06-06T05:53:17.816Z')
      },
      {
        fullValue: 728,
        timestamp: new Date('2017-06-06T05:33:13.185Z')
      },
      {
        fullValue: 605,
        timestamp: new Date('2017-06-06T05:13:09.278Z')
      },
      {
        fullValue: 645,
        timestamp: new Date('2017-06-06T04:53:04.808Z')
      },
      {
        fullValue: 746,
        timestamp: new Date('2017-06-06T04:32:59.029Z')
      },
      {
        fullValue: 615,
        timestamp: new Date('2017-06-06T04:12:55.262Z')
      },
      {
        fullValue: 661,
        timestamp: new Date('2017-06-06T03:52:50.798Z')
      },
      {
        fullValue: 704,
        timestamp: new Date('2017-06-06T03:32:46.881Z')
      },
      {
        fullValue: 625,
        timestamp: new Date('2017-06-06T03:12:43.013Z')
      },
      {
        fullValue: 689,
        timestamp: new Date('2017-06-06T02:52:40.229Z')
      },
      {
        fullValue: 625,
        timestamp: new Date('2017-06-06T02:32:36.279Z')
      },
      {
        fullValue: 637,
        timestamp: new Date('2017-06-06T02:12:32.513Z')
      },
      {
        fullValue: 719,
        timestamp: new Date('2017-06-06T01:52:29.684Z')
      },
      {
        fullValue: 623,
        timestamp: new Date('2017-06-06T01:32:26.115Z')
      }
    ],
    error: null
  },
  2016: {
    isFetching: false,
    data: [
      {
        fullValue: 1115,
        timestamp: new Date('2017-06-13T01:22:34.486Z')
      },
      {
        fullValue: 1167,
        timestamp: new Date('2017-06-13T01:02:30.399Z')
      },
      {
        fullValue: 1191,
        timestamp: new Date('2017-06-13T00:42:25.241Z')
      },
      {
        fullValue: 1118,
        timestamp: new Date('2017-06-13T00:22:19.292Z')
      },
      {
        fullValue: 1170,
        timestamp: new Date('2017-06-13T00:02:13.542Z')
      },
      {
        fullValue: 1179,
        timestamp: new Date('2017-06-12T23:42:08.097Z')
      },
      {
        fullValue: 1118,
        timestamp: new Date('2017-06-12T23:22:02.582Z')
      },
      {
        fullValue: 1183,
        timestamp: new Date('2017-06-12T23:01:57.519Z')
      },
      {
        fullValue: 1139,
        timestamp: new Date('2017-06-12T22:41:51.393Z')
      },
      {
        fullValue: 1146,
        timestamp: new Date('2017-06-12T22:21:45.786Z')
      },
      {
        fullValue: 1204,
        timestamp: new Date('2017-06-12T22:01:40.867Z')
      },
      {
        fullValue: 1275,
        timestamp: new Date('2017-06-12T21:41:35.988Z')
      },
      {
        fullValue: 1312,
        timestamp: new Date('2017-06-12T21:22:30.953Z')
      },
      {
        fullValue: 1169,
        timestamp: new Date('2017-06-12T21:02:25.546Z')
      },
      {
        fullValue: 1052,
        timestamp: new Date('2017-06-12T20:42:19.458Z')
      },
      {
        fullValue: 969,
        timestamp: new Date('2017-06-12T20:22:13.866Z')
      },
      {
        fullValue: 747,
        timestamp: new Date('2017-06-12T20:02:08.605Z')
      },
      {
        fullValue: 753,
        timestamp: new Date('2017-06-12T19:42:03.592Z')
      },
      {
        fullValue: 758,
        timestamp: new Date('2017-06-12T19:21:58.041Z')
      },
      {
        fullValue: 771,
        timestamp: new Date('2017-06-12T19:01:52.903Z')
      },
      {
        fullValue: 657,
        timestamp: new Date('2017-06-12T18:40:47.527Z')
      },
      {
        fullValue: 659,
        timestamp: new Date('2017-06-12T18:20:43.121Z')
      },
      {
        fullValue: 1021,
        timestamp: new Date('2017-06-12T18:00:37.995Z')
      },
      {
        fullValue: 1067,
        timestamp: new Date('2017-06-12T17:40:32.687Z')
      },
      {
        fullValue: 1094,
        timestamp: new Date('2017-06-12T17:19:30.102Z')
      },
      {
        fullValue: 1114,
        timestamp: new Date('2017-06-12T16:59:26.542Z')
      },
      {
        fullValue: 1134,
        timestamp: new Date('2017-06-12T16:39:23.602Z')
      },
      {
        fullValue: 1150,
        timestamp: new Date('2017-06-12T16:19:20.513Z')
      },
      {
        fullValue: 1165,
        timestamp: new Date('2017-06-12T15:59:18.326Z')
      },
      {
        fullValue: 1178,
        timestamp: new Date('2017-06-12T15:39:13.706Z')
      },
      {
        fullValue: 1103,
        timestamp: new Date('2017-06-12T15:19:09.141Z')
      },
      {
        fullValue: 1156,
        timestamp: new Date('2017-06-12T14:59:05.203Z')
      },
      {
        fullValue: 1190,
        timestamp: new Date('2017-06-12T14:39:01.745Z')
      },
      {
        fullValue: 1115,
        timestamp: new Date('2017-06-12T14:18:57.461Z')
      },
      {
        fullValue: 1140,
        timestamp: new Date('2017-06-12T13:48:25.332Z')
      },
      {
        fullValue: 1130,
        timestamp: new Date('2017-06-12T13:28:20.504Z')
      },
      {
        fullValue: 1194,
        timestamp: new Date('2017-06-12T13:08:15.511Z')
      },
      {
        fullValue: 1092,
        timestamp: new Date('2017-06-12T12:48:09.913Z')
      },
      {
        fullValue: 1163,
        timestamp: new Date('2017-06-12T12:28:04.439Z')
      },
      {
        fullValue: 1141,
        timestamp: new Date('2017-06-12T12:07:58.829Z')
      },
      {
        fullValue: 1139,
        timestamp: new Date('2017-06-12T11:47:53.837Z')
      },
      {
        fullValue: 1183,
        timestamp: new Date('2017-06-12T11:27:50.415Z')
      },
      {
        fullValue: 1099,
        timestamp: new Date('2017-06-12T11:07:45.886Z')
      },
      {
        fullValue: 1149,
        timestamp: new Date('2017-06-12T10:47:42.427Z')
      },
      {
        fullValue: 1204,
        timestamp: new Date('2017-06-12T10:27:38.659Z')
      },
      {
        fullValue: 1115,
        timestamp: new Date('2017-06-12T10:07:33.679Z')
      },
      {
        fullValue: 1159,
        timestamp: new Date('2017-06-12T09:47:30.063Z')
      },
      {
        fullValue: 1171,
        timestamp: new Date('2017-06-12T09:27:26.110Z')
      },
      {
        fullValue: 1133,
        timestamp: new Date('2017-06-12T09:07:21.945Z')
      },
      {
        fullValue: 1187,
        timestamp: new Date('2017-06-12T08:47:16.650Z')
      },
      {
        fullValue: 1106,
        timestamp: new Date('2017-06-12T08:27:10.816Z')
      },
      {
        fullValue: 1155,
        timestamp: new Date('2017-06-12T08:07:03.195Z')
      },
      {
        fullValue: 1193,
        timestamp: new Date('2017-06-12T07:46:55.675Z')
      },
      {
        fullValue: 1130,
        timestamp: new Date('2017-06-12T07:26:50.958Z')
      },
      {
        fullValue: 1179,
        timestamp: new Date('2017-06-12T07:06:44.440Z')
      },
      {
        fullValue: 1100,
        timestamp: new Date('2017-06-12T06:46:39.890Z')
      },
      {
        fullValue: 1152,
        timestamp: new Date('2017-06-12T06:26:32.273Z')
      },
      {
        fullValue: 1180,
        timestamp: new Date('2017-06-12T06:06:24.993Z')
      },
      {
        fullValue: 1122,
        timestamp: new Date('2017-06-12T05:46:19.744Z')
      },
      {
        fullValue: 1156,
        timestamp: new Date('2017-06-12T05:26:13.005Z')
      },
      {
        fullValue: 1165,
        timestamp: new Date('2017-06-12T05:06:06.877Z')
      },
      {
        fullValue: 1131,
        timestamp: new Date('2017-06-12T04:46:01.715Z')
      },
      {
        fullValue: 1180,
        timestamp: new Date('2017-06-12T04:25:54.080Z')
      },
      {
        fullValue: 1100,
        timestamp: new Date('2017-06-12T04:05:49.625Z')
      },
      {
        fullValue: 1134,
        timestamp: new Date('2017-06-12T03:45:43.248Z')
      },
      {
        fullValue: 1190,
        timestamp: new Date('2017-06-12T03:25:37.723Z')
      },
      {
        fullValue: 1111,
        timestamp: new Date('2017-06-12T03:05:33.285Z')
      },
      {
        fullValue: 1153,
        timestamp: new Date('2017-06-12T02:45:26.656Z')
      },
      {
        fullValue: 1204,
        timestamp: new Date('2017-06-12T02:25:20.089Z')
      },
      {
        fullValue: 1117,
        timestamp: new Date('2017-06-12T02:05:15.304Z')
      },
      {
        fullValue: 1104,
        timestamp: new Date('2017-06-12T01:45:10.525Z')
      },
      {
        fullValue: 1154,
        timestamp: new Date('2017-06-12T01:25:03.464Z')
      },
      {
        fullValue: 1198,
        timestamp: new Date('2017-06-12T01:04:57.319Z')
      },
      {
        fullValue: 1106,
        timestamp: new Date('2017-06-12T00:44:53.267Z')
      },
      {
        fullValue: 1120,
        timestamp: new Date('2017-06-12T00:24:47.662Z')
      },
      {
        fullValue: 1172,
        timestamp: new Date('2017-06-12T00:04:40.788Z')
      },
      {
        fullValue: 1141,
        timestamp: new Date('2017-06-11T23:44:35.687Z')
      },
      {
        fullValue: 1135,
        timestamp: new Date('2017-06-11T23:24:32.971Z')
      },
      {
        fullValue: 1120,
        timestamp: new Date('2017-06-11T23:04:28.558Z')
      },
      {
        fullValue: 1187,
        timestamp: new Date('2017-06-11T22:43:25.031Z')
      },
      {
        fullValue: 1117,
        timestamp: new Date('2017-06-11T22:23:21.693Z')
      },
      {
        fullValue: 1201,
        timestamp: new Date('2017-06-11T22:03:19.272Z')
      },
      {
        fullValue: 1018,
        timestamp: new Date('2017-06-11T21:43:14.756Z')
      },
      {
        fullValue: 914,
        timestamp: new Date('2017-06-11T21:23:08.598Z')
      },
      {
        fullValue: 930,
        timestamp: new Date('2017-06-11T21:03:02.303Z')
      },
      {
        fullValue: 948,
        timestamp: new Date('2017-06-11T20:42:55.640Z')
      },
      {
        fullValue: 966,
        timestamp: new Date('2017-06-11T20:22:49.469Z')
      },
      {
        fullValue: 985,
        timestamp: new Date('2017-06-11T20:02:43.002Z')
      },
      {
        fullValue: 1007,
        timestamp: new Date('2017-06-11T19:42:36.420Z')
      },
      {
        fullValue: 1025,
        timestamp: new Date('2017-06-11T19:22:30.814Z')
      },
      {
        fullValue: 1044,
        timestamp: new Date('2017-06-11T19:02:25.240Z')
      },
      {
        fullValue: 1071,
        timestamp: new Date('2017-06-11T18:42:18.755Z')
      },
      {
        fullValue: 1095,
        timestamp: new Date('2017-06-11T18:22:12.440Z')
      },
      {
        fullValue: 1117,
        timestamp: new Date('2017-06-11T18:02:06.142Z')
      },
      {
        fullValue: 1141,
        timestamp: new Date('2017-06-11T17:41:59.328Z')
      },
      {
        fullValue: 1167,
        timestamp: new Date('2017-06-11T17:21:52.997Z')
      },
      {
        fullValue: 1140,
        timestamp: new Date('2017-06-11T17:01:46.849Z')
      },
      {
        fullValue: 1034,
        timestamp: new Date('2017-06-11T16:41:40.353Z')
      },
      {
        fullValue: 1049,
        timestamp: new Date('2017-06-11T16:21:34.165Z')
      },
      {
        fullValue: 1078,
        timestamp: new Date('2017-06-11T16:01:27.401Z')
      },
      {
        fullValue: 1101,
        timestamp: new Date('2017-06-11T15:41:21.077Z')
      },
      {
        fullValue: 1151,
        timestamp: new Date('2017-06-11T15:20:14.502Z')
      },
      {
        fullValue: 1198,
        timestamp: new Date('2017-06-11T15:00:09.038Z')
      },
      {
        fullValue: 1122,
        timestamp: new Date('2017-06-11T14:40:04.389Z')
      },
      {
        fullValue: 1152,
        timestamp: new Date('2017-06-11T14:19:57.876Z')
      },
      {
        fullValue: 1143,
        timestamp: new Date('2017-06-11T13:59:52.105Z')
      },
      {
        fullValue: 1143,
        timestamp: new Date('2017-06-11T13:39:46.050Z')
      },
      {
        fullValue: 1203,
        timestamp: new Date('2017-06-11T13:19:38.963Z')
      },
      {
        fullValue: 1116,
        timestamp: new Date('2017-06-11T12:59:34.380Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-11T12:39:29.055Z')
      },
      {
        fullValue: 1195,
        timestamp: new Date('2017-06-11T12:19:23.457Z')
      },
      {
        fullValue: 1105,
        timestamp: new Date('2017-06-11T11:59:17.063Z')
      },
      {
        fullValue: 1166,
        timestamp: new Date('2017-06-11T11:39:11.185Z')
      },
      {
        fullValue: 1112,
        timestamp: new Date('2017-06-11T11:19:04.809Z')
      },
      {
        fullValue: 1152,
        timestamp: new Date('2017-06-11T10:59:00.491Z')
      },
      {
        fullValue: 1206,
        timestamp: new Date('2017-06-11T10:38:54.763Z')
      },
      {
        fullValue: 1127,
        timestamp: new Date('2017-06-11T10:18:49.161Z')
      },
      {
        fullValue: 1178,
        timestamp: new Date('2017-06-11T09:58:41.666Z')
      },
      {
        fullValue: 1125,
        timestamp: new Date('2017-06-11T09:38:35.997Z')
      },
      {
        fullValue: 1127,
        timestamp: new Date('2017-06-11T09:18:29.889Z')
      },
      {
        fullValue: 1159,
        timestamp: new Date('2017-06-11T08:58:23.985Z')
      },
      {
        fullValue: 1197,
        timestamp: new Date('2017-06-11T08:38:17.749Z')
      },
      {
        fullValue: 1121,
        timestamp: new Date('2017-06-11T08:18:10.987Z')
      },
      {
        fullValue: 1166,
        timestamp: new Date('2017-06-11T07:58:04.981Z')
      },
      {
        fullValue: 1177,
        timestamp: new Date('2017-06-11T07:37:59.032Z')
      },
      {
        fullValue: 1126,
        timestamp: new Date('2017-06-11T07:17:52.183Z')
      },
      {
        fullValue: 1176,
        timestamp: new Date('2017-06-11T06:57:46.038Z')
      },
      {
        fullValue: 1101,
        timestamp: new Date('2017-06-11T06:37:39.889Z')
      },
      {
        fullValue: 1149,
        timestamp: new Date('2017-06-11T06:17:32.934Z')
      },
      {
        fullValue: 1200,
        timestamp: new Date('2017-06-11T05:57:25.258Z')
      },
      {
        fullValue: 1115,
        timestamp: new Date('2017-06-11T05:37:20.534Z')
      },
      {
        fullValue: 1166,
        timestamp: new Date('2017-06-11T05:17:13.490Z')
      },
      {
        fullValue: 1099,
        timestamp: new Date('2017-06-11T04:57:07.427Z')
      },
      {
        fullValue: 1155,
        timestamp: new Date('2017-06-11T04:37:01.915Z')
      },
      {
        fullValue: 1187,
        timestamp: new Date('2017-06-11T04:16:56.085Z')
      },
      {
        fullValue: 1125,
        timestamp: new Date('2017-06-11T03:56:49.226Z')
      },
      {
        fullValue: 1188,
        timestamp: new Date('2017-06-11T03:36:43.325Z')
      },
      {
        fullValue: 1113,
        timestamp: new Date('2017-06-11T03:16:38.581Z')
      },
      {
        fullValue: 1166,
        timestamp: new Date('2017-06-11T02:56:31.843Z')
      },
      {
        fullValue: 1177,
        timestamp: new Date('2017-06-11T02:36:26.322Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-11T02:16:20.799Z')
      },
      {
        fullValue: 1170,
        timestamp: new Date('2017-06-11T01:56:14.639Z')
      },
      {
        fullValue: 1159,
        timestamp: new Date('2017-06-11T01:36:08.695Z')
      },
      {
        fullValue: 1120,
        timestamp: new Date('2017-06-11T01:16:02.467Z')
      },
      {
        fullValue: 1171,
        timestamp: new Date('2017-06-11T00:55:56.489Z')
      },
      {
        fullValue: 1171,
        timestamp: new Date('2017-06-11T00:35:50.394Z')
      },
      {
        fullValue: 1129,
        timestamp: new Date('2017-06-11T00:15:43.771Z')
      },
      {
        fullValue: 1179,
        timestamp: new Date('2017-06-10T23:55:38.064Z')
      },
      {
        fullValue: 1130,
        timestamp: new Date('2017-06-10T23:35:31.364Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-10T23:15:25.391Z')
      },
      {
        fullValue: 1195,
        timestamp: new Date('2017-06-10T22:55:19.197Z')
      },
      {
        fullValue: 1108,
        timestamp: new Date('2017-06-10T22:35:14.135Z')
      },
      {
        fullValue: 1159,
        timestamp: new Date('2017-06-10T22:15:06.865Z')
      },
      {
        fullValue: 1135,
        timestamp: new Date('2017-06-10T21:55:01.013Z')
      },
      {
        fullValue: 915,
        timestamp: new Date('2017-06-10T21:34:55.047Z')
      },
      {
        fullValue: 887,
        timestamp: new Date('2017-06-10T21:14:51.338Z')
      },
      {
        fullValue: 900,
        timestamp: new Date('2017-06-10T20:54:48.647Z')
      },
      {
        fullValue: 908,
        timestamp: new Date('2017-06-10T20:34:45.928Z')
      },
      {
        fullValue: 919,
        timestamp: new Date('2017-06-10T20:14:43.451Z')
      },
      {
        fullValue: 927,
        timestamp: new Date('2017-06-10T19:54:41.019Z')
      },
      {
        fullValue: 942,
        timestamp: new Date('2017-06-10T19:34:37.936Z')
      },
      {
        fullValue: 951,
        timestamp: new Date('2017-06-10T19:14:35.196Z')
      },
      {
        fullValue: 965,
        timestamp: new Date('2017-06-10T18:54:31.643Z')
      },
      {
        fullValue: 981,
        timestamp: new Date('2017-06-10T18:34:26.074Z')
      },
      {
        fullValue: 995,
        timestamp: new Date('2017-06-10T18:14:23.590Z')
      },
      {
        fullValue: 1007,
        timestamp: new Date('2017-06-10T17:54:20.002Z')
      },
      {
        fullValue: 1020,
        timestamp: new Date('2017-06-10T17:34:16.297Z')
      },
      {
        fullValue: 1031,
        timestamp: new Date('2017-06-10T17:14:13.462Z')
      },
      {
        fullValue: 1047,
        timestamp: new Date('2017-06-10T16:54:09.955Z')
      },
      {
        fullValue: 1062,
        timestamp: new Date('2017-06-10T16:34:06.340Z')
      },
      {
        fullValue: 1080,
        timestamp: new Date('2017-06-10T16:14:03.529Z')
      },
      {
        fullValue: 1090,
        timestamp: new Date('2017-06-10T15:54:01.017Z')
      },
      {
        fullValue: 1102,
        timestamp: new Date('2017-06-10T15:33:58.180Z')
      },
      {
        fullValue: 1154,
        timestamp: new Date('2017-06-10T15:13:51.796Z')
      },
      {
        fullValue: 1167,
        timestamp: new Date('2017-06-10T14:53:45.278Z')
      },
      {
        fullValue: 1133,
        timestamp: new Date('2017-06-10T14:33:40.857Z')
      },
      {
        fullValue: 1178,
        timestamp: new Date('2017-06-10T14:13:35.002Z')
      },
      {
        fullValue: 1101,
        timestamp: new Date('2017-06-10T13:53:28.680Z')
      },
      {
        fullValue: 1157,
        timestamp: new Date('2017-06-10T13:33:23.024Z')
      },
      {
        fullValue: 1206,
        timestamp: new Date('2017-06-10T13:13:17.763Z')
      },
      {
        fullValue: 1114,
        timestamp: new Date('2017-06-10T12:53:10.829Z')
      },
      {
        fullValue: 1157,
        timestamp: new Date('2017-06-10T12:33:05.334Z')
      },
      {
        fullValue: 1203,
        timestamp: new Date('2017-06-10T12:12:59.099Z')
      },
      {
        fullValue: 1125,
        timestamp: new Date('2017-06-10T11:52:53.880Z')
      },
      {
        fullValue: 1161,
        timestamp: new Date('2017-06-10T11:32:46.723Z')
      },
      {
        fullValue: 1206,
        timestamp: new Date('2017-06-10T11:12:38.811Z')
      },
      {
        fullValue: 1115,
        timestamp: new Date('2017-06-10T10:52:34.295Z')
      },
      {
        fullValue: 1158,
        timestamp: new Date('2017-06-10T10:32:29.365Z')
      },
      {
        fullValue: 1200,
        timestamp: new Date('2017-06-10T10:12:25.012Z')
      },
      {
        fullValue: 1115,
        timestamp: new Date('2017-06-10T09:52:18.187Z')
      },
      {
        fullValue: 1161,
        timestamp: new Date('2017-06-10T09:31:13.190Z')
      },
      {
        fullValue: 1208,
        timestamp: new Date('2017-06-10T09:11:06.647Z')
      },
      {
        fullValue: 1107,
        timestamp: new Date('2017-06-10T08:51:00.312Z')
      },
      {
        fullValue: 1160,
        timestamp: new Date('2017-06-10T08:30:54.964Z')
      },
      {
        fullValue: 1200,
        timestamp: new Date('2017-06-10T08:10:48.904Z')
      },
      {
        fullValue: 1110,
        timestamp: new Date('2017-06-10T07:50:42.167Z')
      },
      {
        fullValue: 1159,
        timestamp: new Date('2017-06-10T07:30:34.361Z')
      },
      {
        fullValue: 1200,
        timestamp: new Date('2017-06-10T07:10:27.811Z')
      },
      {
        fullValue: 1110,
        timestamp: new Date('2017-06-10T06:50:24.248Z')
      },
      {
        fullValue: 1164,
        timestamp: new Date('2017-06-10T06:30:21.703Z')
      },
      {
        fullValue: 1179,
        timestamp: new Date('2017-06-10T06:10:17.041Z')
      },
      {
        fullValue: 1125,
        timestamp: new Date('2017-06-10T05:50:10.123Z')
      },
      {
        fullValue: 1168,
        timestamp: new Date('2017-06-10T05:30:04.628Z')
      },
      {
        fullValue: 1147,
        timestamp: new Date('2017-06-10T05:09:59.723Z')
      },
      {
        fullValue: 1132,
        timestamp: new Date('2017-06-10T04:49:56.027Z')
      },
      {
        fullValue: 1172,
        timestamp: new Date('2017-06-10T04:29:52.873Z')
      },
      {
        fullValue: 1130,
        timestamp: new Date('2017-06-10T04:09:49.180Z')
      },
      {
        fullValue: 1133,
        timestamp: new Date('2017-06-10T03:49:45.562Z')
      },
      {
        fullValue: 1185,
        timestamp: new Date('2017-06-10T03:29:42.492Z')
      },
      {
        fullValue: 1105,
        timestamp: new Date('2017-06-10T03:09:38.925Z')
      },
      {
        fullValue: 1129,
        timestamp: new Date('2017-06-10T02:49:32.408Z')
      },
      {
        fullValue: 1179,
        timestamp: new Date('2017-06-10T02:29:26.543Z')
      },
      {
        fullValue: 1098,
        timestamp: new Date('2017-06-10T02:09:21.743Z')
      },
      {
        fullValue: 1132,
        timestamp: new Date('2017-06-10T01:49:15.450Z')
      },
      {
        fullValue: 1171,
        timestamp: new Date('2017-06-10T01:29:11.875Z')
      },
      {
        fullValue: 1168,
        timestamp: new Date('2017-06-10T01:09:07.968Z')
      },
      {
        fullValue: 1124,
        timestamp: new Date('2017-06-10T00:49:10.033Z')
      },
      {
        fullValue: 1169,
        timestamp: new Date('2017-06-10T00:30:24.943Z')
      },
      {
        fullValue: 1206,
        timestamp: new Date('2017-06-10T00:12:17.509Z')
      },
      {
        fullValue: 1107,
        timestamp: new Date('2017-06-09T23:51:54.672Z')
      },
      {
        fullValue: 1163,
        timestamp: new Date('2017-06-09T23:31:48.108Z')
      },
      {
        fullValue: 1180,
        timestamp: new Date('2017-06-09T23:11:42.825Z')
      },
      {
        fullValue: 1129,
        timestamp: new Date('2017-06-09T22:50:37.333Z')
      },
      {
        fullValue: 1178,
        timestamp: new Date('2017-06-09T22:30:31.551Z')
      },
      {
        fullValue: 1083,
        timestamp: new Date('2017-06-09T22:10:25.398Z')
      },
      {
        fullValue: 840,
        timestamp: new Date('2017-06-09T21:46:56.125Z')
      },
      {
        fullValue: 596,
        timestamp: new Date('2017-06-09T21:26:50.226Z')
      },
      {
        fullValue: 832,
        timestamp: new Date('2017-06-09T21:06:44.526Z')
      },
      {
        fullValue: 1127,
        timestamp: new Date('2017-06-09T20:46:38.811Z')
      },
      {
        fullValue: 1234,
        timestamp: new Date('2017-06-09T20:26:32.895Z')
      },
      {
        fullValue: 1255,
        timestamp: new Date('2017-06-09T20:06:26.043Z')
      },
      {
        fullValue: 1267,
        timestamp: new Date('2017-06-09T19:46:19.739Z')
      },
      {
        fullValue: 1287,
        timestamp: new Date('2017-06-09T19:26:14.781Z')
      },
      {
        fullValue: 1310,
        timestamp: new Date('2017-06-09T19:06:10.429Z')
      },
      {
        fullValue: 1336,
        timestamp: new Date('2017-06-09T18:46:05.832Z')
      },
      {
        fullValue: 1389,
        timestamp: new Date('2017-06-09T18:26:00.164Z')
      },
      {
        fullValue: 1425,
        timestamp: new Date('2017-06-09T18:05:53.626Z')
      },
      {
        fullValue: 1459,
        timestamp: new Date('2017-06-09T17:45:48.057Z')
      },
      {
        fullValue: 1472,
        timestamp: new Date('2017-06-09T17:25:41.379Z')
      },
      {
        fullValue: 1263,
        timestamp: new Date('2017-06-09T17:05:34.693Z')
      },
      {
        fullValue: 1281,
        timestamp: new Date('2017-06-09T16:45:27.966Z')
      },
      {
        fullValue: 1299,
        timestamp: new Date('2017-06-09T16:25:21.118Z')
      },
      {
        fullValue: 1293,
        timestamp: new Date('2017-06-09T16:05:14.670Z')
      },
      {
        fullValue: 1247,
        timestamp: new Date('2017-06-09T15:45:11.086Z')
      },
      {
        fullValue: 1276,
        timestamp: new Date('2017-06-09T15:25:06.615Z')
      },
      {
        fullValue: 1329,
        timestamp: new Date('2017-06-09T15:05:01.727Z')
      },
      {
        fullValue: 1215,
        timestamp: new Date('2017-06-09T14:45:57.694Z')
      },
      {
        fullValue: 1112,
        timestamp: new Date('2017-06-09T14:25:52.095Z')
      },
      {
        fullValue: 1151,
        timestamp: new Date('2017-06-09T14:05:44.667Z')
      },
      {
        fullValue: 1180,
        timestamp: new Date('2017-06-09T13:45:38.046Z')
      },
      {
        fullValue: 1113,
        timestamp: new Date('2017-06-09T13:25:32.434Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-09T13:05:26.166Z')
      },
      {
        fullValue: 1183,
        timestamp: new Date('2017-06-09T12:45:19.023Z')
      },
      {
        fullValue: 1144,
        timestamp: new Date('2017-06-09T12:25:13.461Z')
      },
      {
        fullValue: 1124,
        timestamp: new Date('2017-06-09T12:05:08.633Z')
      },
      {
        fullValue: 1176,
        timestamp: new Date('2017-06-09T11:45:00.823Z')
      },
      {
        fullValue: 1212,
        timestamp: new Date('2017-06-09T11:24:53.679Z')
      },
      {
        fullValue: 1116,
        timestamp: new Date('2017-06-09T11:04:48.919Z')
      },
      {
        fullValue: 1147,
        timestamp: new Date('2017-06-09T10:44:41.192Z')
      },
      {
        fullValue: 1173,
        timestamp: new Date('2017-06-09T10:24:35.084Z')
      },
      {
        fullValue: 1188,
        timestamp: new Date('2017-06-09T10:04:28.542Z')
      },
      {
        fullValue: 1120,
        timestamp: new Date('2017-06-09T09:44:23.283Z')
      },
      {
        fullValue: 1160,
        timestamp: new Date('2017-06-09T09:24:15.566Z')
      },
      {
        fullValue: 1200,
        timestamp: new Date('2017-06-09T09:04:08.046Z')
      },
      {
        fullValue: 1110,
        timestamp: new Date('2017-06-09T08:44:02.279Z')
      },
      {
        fullValue: 1146,
        timestamp: new Date('2017-06-09T08:23:55.619Z')
      },
      {
        fullValue: 1182,
        timestamp: new Date('2017-06-09T08:03:47.942Z')
      },
      {
        fullValue: 1100,
        timestamp: new Date('2017-06-09T07:43:42.753Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-09T07:23:35.105Z')
      },
      {
        fullValue: 1161,
        timestamp: new Date('2017-06-09T07:03:29.098Z')
      },
      {
        fullValue: 1203,
        timestamp: new Date('2017-06-09T06:43:23.004Z')
      },
      {
        fullValue: 1118,
        timestamp: new Date('2017-06-09T06:23:17.353Z')
      },
      {
        fullValue: 1161,
        timestamp: new Date('2017-06-09T06:03:09.789Z')
      },
      {
        fullValue: 1196,
        timestamp: new Date('2017-06-09T05:43:02.100Z')
      },
      {
        fullValue: 1110,
        timestamp: new Date('2017-06-09T05:22:57.075Z')
      },
      {
        fullValue: 1118,
        timestamp: new Date('2017-06-09T05:02:51.157Z')
      },
      {
        fullValue: 1155,
        timestamp: new Date('2017-06-09T04:42:44.901Z')
      },
      {
        fullValue: 1194,
        timestamp: new Date('2017-06-09T04:22:38.561Z')
      },
      {
        fullValue: 1105,
        timestamp: new Date('2017-06-09T04:02:34.037Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-09T03:42:27.307Z')
      },
      {
        fullValue: 1174,
        timestamp: new Date('2017-06-09T03:22:19.639Z')
      },
      {
        fullValue: 1168,
        timestamp: new Date('2017-06-09T03:02:13.069Z')
      },
      {
        fullValue: 1112,
        timestamp: new Date('2017-06-09T02:42:08.660Z')
      },
      {
        fullValue: 1146,
        timestamp: new Date('2017-06-09T02:22:02.693Z')
      },
      {
        fullValue: 1179,
        timestamp: new Date('2017-06-09T02:01:57.061Z')
      },
      {
        fullValue: 1125,
        timestamp: new Date('2017-06-09T01:41:50.541Z')
      },
      {
        fullValue: 1124,
        timestamp: new Date('2017-06-09T01:21:43.421Z')
      },
      {
        fullValue: 1163,
        timestamp: new Date('2017-06-09T01:01:35.927Z')
      },
      {
        fullValue: 1206,
        timestamp: new Date('2017-06-09T00:41:28.761Z')
      },
      {
        fullValue: 1107,
        timestamp: new Date('2017-06-09T00:21:23.873Z')
      },
      {
        fullValue: 1146,
        timestamp: new Date('2017-06-09T00:01:17.408Z')
      },
      {
        fullValue: 1182,
        timestamp: new Date('2017-06-08T23:41:11.386Z')
      },
      {
        fullValue: 1168,
        timestamp: new Date('2017-06-08T23:21:06.227Z')
      },
      {
        fullValue: 1126,
        timestamp: new Date('2017-06-08T23:01:01.330Z')
      },
      {
        fullValue: 1167,
        timestamp: new Date('2017-06-08T22:40:53.517Z')
      },
      {
        fullValue: 1178,
        timestamp: new Date('2017-06-08T22:20:46.266Z')
      },
      {
        fullValue: 1126,
        timestamp: new Date('2017-06-08T22:00:40.642Z')
      },
      {
        fullValue: 1170,
        timestamp: new Date('2017-06-08T21:40:34.607Z')
      },
      {
        fullValue: 1191,
        timestamp: new Date('2017-06-08T21:20:30.134Z')
      },
      {
        fullValue: 1258,
        timestamp: new Date('2017-06-08T21:00:26.398Z')
      },
      {
        fullValue: 1168,
        timestamp: new Date('2017-06-08T20:40:20.971Z')
      },
      {
        fullValue: 1183,
        timestamp: new Date('2017-06-08T20:20:14.408Z')
      },
      {
        fullValue: 1198,
        timestamp: new Date('2017-06-08T20:00:09.018Z')
      },
      {
        fullValue: 1214,
        timestamp: new Date('2017-06-08T19:40:02.506Z')
      },
      {
        fullValue: 1238,
        timestamp: new Date('2017-06-08T19:19:55.993Z')
      },
      {
        fullValue: 1166,
        timestamp: new Date('2017-06-08T18:59:50.834Z')
      },
      {
        fullValue: 1088,
        timestamp: new Date('2017-06-08T18:39:47.601Z')
      },
      {
        fullValue: 1102,
        timestamp: new Date('2017-06-08T18:19:45.157Z')
      },
      {
        fullValue: 1113,
        timestamp: new Date('2017-06-08T17:59:42.089Z')
      },
      {
        fullValue: 1135,
        timestamp: new Date('2017-06-08T17:40:38.334Z')
      },
      {
        fullValue: 1144,
        timestamp: new Date('2017-06-08T17:20:33.287Z')
      },
      {
        fullValue: 1164,
        timestamp: new Date('2017-06-08T17:00:29.717Z')
      },
      {
        fullValue: 1174,
        timestamp: new Date('2017-06-08T16:40:25.950Z')
      },
      {
        fullValue: 1189,
        timestamp: new Date('2017-06-08T16:20:23.259Z')
      },
      {
        fullValue: 1171,
        timestamp: new Date('2017-06-08T16:00:20.582Z')
      },
      {
        fullValue: 1179,
        timestamp: new Date('2017-06-08T15:40:17.831Z')
      },
      {
        fullValue: 1102,
        timestamp: new Date('2017-06-08T15:20:14.953Z')
      },
      {
        fullValue: 1131,
        timestamp: new Date('2017-06-08T15:00:08.565Z')
      },
      {
        fullValue: 1159,
        timestamp: new Date('2017-06-08T14:40:03.127Z')
      },
      {
        fullValue: 1166,
        timestamp: new Date('2017-06-08T14:19:57.347Z')
      },
      {
        fullValue: 1130,
        timestamp: new Date('2017-06-08T13:59:51.132Z')
      },
      {
        fullValue: 1169,
        timestamp: new Date('2017-06-08T13:39:45.549Z')
      },
      {
        fullValue: 1196,
        timestamp: new Date('2017-06-08T13:19:39.570Z')
      },
      {
        fullValue: 1119,
        timestamp: new Date('2017-06-08T12:59:33.222Z')
      },
      {
        fullValue: 1151,
        timestamp: new Date('2017-06-08T12:39:27.480Z')
      },
      {
        fullValue: 1196,
        timestamp: new Date('2017-06-08T12:19:20.651Z')
      },
      {
        fullValue: 1109,
        timestamp: new Date('2017-06-08T11:59:14.911Z')
      },
      {
        fullValue: 1140,
        timestamp: new Date('2017-06-08T11:39:07.982Z')
      },
      {
        fullValue: 1178,
        timestamp: new Date('2017-06-08T11:19:01.178Z')
      },
      {
        fullValue: 1116,
        timestamp: new Date('2017-06-08T10:58:55.017Z')
      },
      {
        fullValue: 1139,
        timestamp: new Date('2017-06-08T10:38:49.539Z')
      },
      {
        fullValue: 1176,
        timestamp: new Date('2017-06-08T10:18:44.040Z')
      },
      {
        fullValue: 1100,
        timestamp: new Date('2017-06-08T09:57:37.272Z')
      },
      {
        fullValue: 1134,
        timestamp: new Date('2017-06-08T09:37:31.661Z')
      },
      {
        fullValue: 1169,
        timestamp: new Date('2017-06-08T09:17:26.112Z')
      },
      {
        fullValue: 1181,
        timestamp: new Date('2017-06-08T08:57:21.079Z')
      },
      {
        fullValue: 1120,
        timestamp: new Date('2017-06-08T08:37:14.706Z')
      },
      {
        fullValue: 1159,
        timestamp: new Date('2017-06-08T08:17:08.624Z')
      },
      {
        fullValue: 1203,
        timestamp: new Date('2017-06-08T07:57:02.953Z')
      },
      {
        fullValue: 1115,
        timestamp: new Date('2017-06-08T07:35:57.466Z')
      },
      {
        fullValue: 1153,
        timestamp: new Date('2017-06-08T07:13:49.854Z')
      },
      {
        fullValue: 1188,
        timestamp: new Date('2017-06-08T06:53:42.776Z')
      },
      {
        fullValue: 1104,
        timestamp: new Date('2017-06-08T06:33:38.198Z')
      },
      {
        fullValue: 1146,
        timestamp: new Date('2017-06-08T06:11:31.186Z')
      },
      {
        fullValue: 1180,
        timestamp: new Date('2017-06-08T05:51:25.594Z')
      },
      {
        fullValue: 1155,
        timestamp: new Date('2017-06-08T05:31:19.499Z')
      },
      {
        fullValue: 1128,
        timestamp: new Date('2017-06-08T05:11:13.733Z')
      },
      {
        fullValue: 1159,
        timestamp: new Date('2017-06-08T04:51:07.615Z')
      },
      {
        fullValue: 1198,
        timestamp: new Date('2017-06-08T04:31:02.004Z')
      },
      {
        fullValue: 1115,
        timestamp: new Date('2017-06-08T04:06:54.115Z')
      },
      {
        fullValue: 1157,
        timestamp: new Date('2017-06-08T03:46:48.377Z')
      },
      {
        fullValue: 1180,
        timestamp: new Date('2017-06-08T03:26:42.565Z')
      },
      {
        fullValue: 1138,
        timestamp: new Date('2017-06-08T03:06:36.667Z')
      },
      {
        fullValue: 1122,
        timestamp: new Date('2017-06-08T02:46:30.808Z')
      },
      {
        fullValue: 1157,
        timestamp: new Date('2017-06-08T02:26:23.735Z')
      },
      {
        fullValue: 1190,
        timestamp: new Date('2017-06-08T02:06:16.685Z')
      },
      {
        fullValue: 1104,
        timestamp: new Date('2017-06-08T01:46:09.705Z')
      },
      {
        fullValue: 1135,
        timestamp: new Date('2017-06-08T01:26:04.166Z')
      },
      {
        fullValue: 1165,
        timestamp: new Date('2017-06-08T01:05:57.971Z')
      },
      {
        fullValue: 1195,
        timestamp: new Date('2017-06-08T00:45:53.217Z')
      },
      {
        fullValue: 1105,
        timestamp: new Date('2017-06-08T00:25:46.893Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-08T00:05:41.403Z')
      },
      {
        fullValue: 1180,
        timestamp: new Date('2017-06-07T23:45:35.988Z')
      },
      {
        fullValue: 1117,
        timestamp: new Date('2017-06-07T23:25:29.483Z')
      },
      {
        fullValue: 1133,
        timestamp: new Date('2017-06-07T23:05:23.837Z')
      },
      {
        fullValue: 1168,
        timestamp: new Date('2017-06-07T22:45:16.894Z')
      },
      {
        fullValue: 1194,
        timestamp: new Date('2017-06-07T22:25:09.773Z')
      },
      {
        fullValue: 1231,
        timestamp: new Date('2017-06-07T22:05:02.650Z')
      },
      {
        fullValue: 1251,
        timestamp: new Date('2017-06-07T21:44:55.767Z')
      },
      {
        fullValue: 1258,
        timestamp: new Date('2017-06-07T21:24:50.155Z')
      },
      {
        fullValue: 1277,
        timestamp: new Date('2017-06-07T21:04:45.711Z')
      },
      {
        fullValue: 1289,
        timestamp: new Date('2017-06-07T20:44:41.889Z')
      },
      {
        fullValue: 1301,
        timestamp: new Date('2017-06-07T20:24:36.581Z')
      },
      {
        fullValue: 1313,
        timestamp: new Date('2017-06-07T20:04:32.331Z')
      },
      {
        fullValue: 1327,
        timestamp: new Date('2017-06-07T19:44:30.353Z')
      },
      {
        fullValue: 1349,
        timestamp: new Date('2017-06-07T19:20:53.206Z')
      },
      {
        fullValue: 1360,
        timestamp: new Date('2017-06-07T19:00:48.916Z')
      },
      {
        fullValue: 1376,
        timestamp: new Date('2017-06-07T18:38:51.621Z')
      },
      {
        fullValue: 1391,
        timestamp: new Date('2017-06-07T18:15:14.418Z')
      },
      {
        fullValue: 1412,
        timestamp: new Date('2017-06-07T17:53:10.469Z')
      },
      {
        fullValue: 1422,
        timestamp: new Date('2017-06-07T17:33:04.474Z')
      },
      {
        fullValue: 1447,
        timestamp: new Date('2017-06-07T17:13:00.618Z')
      },
      {
        fullValue: 1469,
        timestamp: new Date('2017-06-07T16:51:55.500Z')
      },
      {
        fullValue: 1562,
        timestamp: new Date('2017-06-07T16:31:51.477Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-07T16:06:24.878Z')
      },
      {
        fullValue: 1633,
        timestamp: new Date('2017-06-07T15:46:19.704Z')
      },
      {
        fullValue: 1936,
        timestamp: new Date('2017-06-07T15:27:14.182Z')
      },
      {
        fullValue: 1874,
        timestamp: new Date('2017-06-07T15:07:09.454Z')
      },
      {
        fullValue: 1673,
        timestamp: new Date('2017-06-07T14:47:03.892Z')
      },
      {
        fullValue: 1515,
        timestamp: new Date('2017-06-07T14:26:58.106Z')
      },
      {
        fullValue: 1268,
        timestamp: new Date('2017-06-07T14:06:51.765Z')
      },
      {
        fullValue: 1106,
        timestamp: new Date('2017-06-07T13:46:47.495Z')
      },
      {
        fullValue: 1131,
        timestamp: new Date('2017-06-07T13:26:41.270Z')
      },
      {
        fullValue: 1160,
        timestamp: new Date('2017-06-07T13:06:35.232Z')
      },
      {
        fullValue: 1192,
        timestamp: new Date('2017-06-07T12:46:29.429Z')
      },
      {
        fullValue: 1221,
        timestamp: new Date('2017-06-07T12:26:23.561Z')
      },
      {
        fullValue: 1099,
        timestamp: new Date('2017-06-07T12:06:19.449Z')
      },
      {
        fullValue: 1126,
        timestamp: new Date('2017-06-07T11:46:13.167Z')
      },
      {
        fullValue: 1167,
        timestamp: new Date('2017-06-07T11:26:07.078Z')
      },
      {
        fullValue: 1202,
        timestamp: new Date('2017-06-07T11:06:00.597Z')
      },
      {
        fullValue: 1186,
        timestamp: new Date('2017-06-07T10:45:55.351Z')
      },
      {
        fullValue: 1112,
        timestamp: new Date('2017-06-07T10:25:50.697Z')
      },
      {
        fullValue: 1154,
        timestamp: new Date('2017-06-07T10:05:44.763Z')
      },
      {
        fullValue: 1191,
        timestamp: new Date('2017-06-07T09:45:38.847Z')
      },
      {
        fullValue: 1152,
        timestamp: new Date('2017-06-07T09:25:32.338Z')
      },
      {
        fullValue: 1124,
        timestamp: new Date('2017-06-07T09:05:26.946Z')
      },
      {
        fullValue: 1158,
        timestamp: new Date('2017-06-07T08:45:20.936Z')
      },
      {
        fullValue: 1196,
        timestamp: new Date('2017-06-07T08:25:15.544Z')
      },
      {
        fullValue: 1149,
        timestamp: new Date('2017-06-07T08:05:10.716Z')
      },
      {
        fullValue: 1126,
        timestamp: new Date('2017-06-07T07:45:05.325Z')
      },
      {
        fullValue: 1167,
        timestamp: new Date('2017-06-07T07:24:59.847Z')
      },
      {
        fullValue: 1208,
        timestamp: new Date('2017-06-07T07:04:53.517Z')
      },
      {
        fullValue: 1098,
        timestamp: new Date('2017-06-07T06:44:49.574Z')
      },
      {
        fullValue: 1131,
        timestamp: new Date('2017-06-07T06:24:43.934Z')
      },
      {
        fullValue: 1172,
        timestamp: new Date('2017-06-07T06:04:37.950Z')
      },
      {
        fullValue: 1221,
        timestamp: new Date('2017-06-07T05:44:31.647Z')
      },
      {
        fullValue: 1109,
        timestamp: new Date('2017-06-07T05:24:27.955Z')
      },
      {
        fullValue: 1156,
        timestamp: new Date('2017-06-07T05:04:22.058Z')
      },
      {
        fullValue: 1201,
        timestamp: new Date('2017-06-07T04:44:16.285Z')
      },
      {
        fullValue: 1145,
        timestamp: new Date('2017-06-07T04:24:11.453Z')
      },
      {
        fullValue: 1128,
        timestamp: new Date('2017-06-07T04:03:05.778Z')
      },
      {
        fullValue: 1172,
        timestamp: new Date('2017-06-07T03:43:00.049Z')
      },
      {
        fullValue: 1198,
        timestamp: new Date('2017-06-07T03:21:53.316Z')
      },
      {
        fullValue: 1118,
        timestamp: new Date('2017-06-07T03:01:49.578Z')
      },
      {
        fullValue: 1158,
        timestamp: new Date('2017-06-07T02:41:43.588Z')
      },
      {
        fullValue: 1203,
        timestamp: new Date('2017-06-07T02:21:37.957Z')
      },
      {
        fullValue: 1102,
        timestamp: new Date('2017-06-07T02:01:32.651Z')
      },
      {
        fullValue: 1138,
        timestamp: new Date('2017-06-07T01:41:26.939Z')
      },
      {
        fullValue: 1184,
        timestamp: new Date('2017-06-07T01:21:21.722Z')
      },
      {
        fullValue: 1231,
        timestamp: new Date('2017-06-07T01:01:15.819Z')
      },
      {
        fullValue: 1275,
        timestamp: new Date('2017-06-07T00:41:10.351Z')
      },
      {
        fullValue: 1321,
        timestamp: new Date('2017-06-07T00:21:05.146Z')
      },
      {
        fullValue: 1371,
        timestamp: new Date('2017-06-07T00:00:59.540Z')
      },
      {
        fullValue: 1421,
        timestamp: new Date('2017-06-06T23:40:54.586Z')
      },
      {
        fullValue: 1473,
        timestamp: new Date('2017-06-06T23:20:49.233Z')
      },
      {
        fullValue: 1536,
        timestamp: new Date('2017-06-06T23:00:44.183Z')
      },
      {
        fullValue: 1592,
        timestamp: new Date('2017-06-06T22:40:39.485Z')
      },
      {
        fullValue: 1663,
        timestamp: new Date('2017-06-06T22:20:33.611Z')
      },
      {
        fullValue: 1730,
        timestamp: new Date('2017-06-06T22:00:28.379Z')
      },
      {
        fullValue: 1801,
        timestamp: new Date('2017-06-06T21:40:22.546Z')
      },
      {
        fullValue: 1834,
        timestamp: new Date('2017-06-06T21:20:18.381Z')
      },
      {
        fullValue: 1877,
        timestamp: new Date('2017-06-06T21:00:14.421Z')
      },
      {
        fullValue: 1931,
        timestamp: new Date('2017-06-06T20:40:10.602Z')
      },
      {
        fullValue: 1982,
        timestamp: new Date('2017-06-06T20:20:06.729Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T20:00:02.707Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T19:39:59.578Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T19:16:13.106Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T18:56:09.087Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T18:36:05.216Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T18:16:01.274Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T17:55:57.416Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T17:35:53.714Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T17:15:50.318Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T16:55:46.419Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T16:35:42.753Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T16:15:39.570Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T15:55:33.686Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T15:35:31.019Z')
      },
      {
        fullValue: 2000,
        timestamp: new Date('2017-06-06T15:15:26.108Z')
      },
      {
        fullValue: 1783,
        timestamp: new Date('2017-06-06T14:55:21.007Z')
      },
      {
        fullValue: 1535,
        timestamp: new Date('2017-06-06T14:35:16.251Z')
      },
      {
        fullValue: 1232,
        timestamp: new Date('2017-06-06T14:15:10.664Z')
      },
      {
        fullValue: 1151,
        timestamp: new Date('2017-06-06T13:55:06.687Z')
      },
      {
        fullValue: 1143,
        timestamp: new Date('2017-06-06T13:35:03.110Z')
      },
      {
        fullValue: 1154,
        timestamp: new Date('2017-06-06T13:14:58.222Z')
      },
      {
        fullValue: 1120,
        timestamp: new Date('2017-06-06T12:54:53.537Z')
      },
      {
        fullValue: 1134,
        timestamp: new Date('2017-06-06T12:34:47.222Z')
      },
      {
        fullValue: 1189,
        timestamp: new Date('2017-06-06T12:14:42.788Z')
      },
      {
        fullValue: 1129,
        timestamp: new Date('2017-06-06T11:54:37.788Z')
      },
      {
        fullValue: 1203,
        timestamp: new Date('2017-06-06T11:34:33.374Z')
      },
      {
        fullValue: 1124,
        timestamp: new Date('2017-06-06T11:14:29.245Z')
      },
      {
        fullValue: 1196,
        timestamp: new Date('2017-06-06T10:54:24.922Z')
      },
      {
        fullValue: 1120,
        timestamp: new Date('2017-06-06T10:34:20.412Z')
      },
      {
        fullValue: 1192,
        timestamp: new Date('2017-06-06T10:14:15.728Z')
      },
      {
        fullValue: 1120,
        timestamp: new Date('2017-06-06T09:54:10.068Z')
      },
      {
        fullValue: 1199,
        timestamp: new Date('2017-06-06T09:34:06.560Z')
      },
      {
        fullValue: 1125,
        timestamp: new Date('2017-06-06T09:14:01.652Z')
      },
      {
        fullValue: 1205,
        timestamp: new Date('2017-06-06T08:53:58.096Z')
      },
      {
        fullValue: 1118,
        timestamp: new Date('2017-06-06T08:33:53.339Z')
      },
      {
        fullValue: 1203,
        timestamp: new Date('2017-06-06T08:13:49.070Z')
      },
      {
        fullValue: 1134,
        timestamp: new Date('2017-06-06T07:53:45.356Z')
      },
      {
        fullValue: 1183,
        timestamp: new Date('2017-06-06T07:33:41.461Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-06T07:13:36.406Z')
      },
      {
        fullValue: 1213,
        timestamp: new Date('2017-06-06T06:53:32.487Z')
      },
      {
        fullValue: 1136,
        timestamp: new Date('2017-06-06T06:33:27.630Z')
      },
      {
        fullValue: 1192,
        timestamp: new Date('2017-06-06T06:13:23.912Z')
      },
      {
        fullValue: 1117,
        timestamp: new Date('2017-06-06T05:53:17.816Z')
      },
      {
        fullValue: 1178,
        timestamp: new Date('2017-06-06T05:33:13.185Z')
      },
      {
        fullValue: 1118,
        timestamp: new Date('2017-06-06T05:13:09.278Z')
      },
      {
        fullValue: 1179,
        timestamp: new Date('2017-06-06T04:53:04.808Z')
      },
      {
        fullValue: 1107,
        timestamp: new Date('2017-06-06T04:32:59.029Z')
      },
      {
        fullValue: 1161,
        timestamp: new Date('2017-06-06T04:12:55.262Z')
      },
      {
        fullValue: 1226,
        timestamp: new Date('2017-06-06T03:52:50.798Z')
      },
      {
        fullValue: 1283,
        timestamp: new Date('2017-06-06T03:32:46.881Z')
      },
      {
        fullValue: 1343,
        timestamp: new Date('2017-06-06T03:12:43.013Z')
      },
      {
        fullValue: 1411,
        timestamp: new Date('2017-06-06T02:52:40.229Z')
      },
      {
        fullValue: 1466,
        timestamp: new Date('2017-06-06T02:32:36.279Z')
      },
      {
        fullValue: 1537,
        timestamp: new Date('2017-06-06T02:12:32.513Z')
      },
      {
        fullValue: 1608,
        timestamp: new Date('2017-06-06T01:52:29.684Z')
      },
      {
        fullValue: 1672,
        timestamp: new Date('2017-06-06T01:32:26.115Z')
      }
    ],
    error: null
  },
  2018: {
    isFetching: false,
    data: [
      {
        fullValue: 1617,
        timestamp: new Date('2017-06-13T01:22:34.486Z')
      },
      {
        fullValue: 1618,
        timestamp: new Date('2017-06-13T01:02:30.399Z')
      },
      {
        fullValue: 1620,
        timestamp: new Date('2017-06-13T00:42:25.241Z')
      },
      {
        fullValue: 1621,
        timestamp: new Date('2017-06-13T00:22:19.292Z')
      },
      {
        fullValue: 1620,
        timestamp: new Date('2017-06-13T00:02:13.542Z')
      },
      {
        fullValue: 1608,
        timestamp: new Date('2017-06-12T23:42:08.097Z')
      },
      {
        fullValue: 1614,
        timestamp: new Date('2017-06-12T23:22:02.582Z')
      },
      {
        fullValue: 1617,
        timestamp: new Date('2017-06-12T23:01:57.519Z')
      },
      {
        fullValue: 1617,
        timestamp: new Date('2017-06-12T22:41:51.393Z')
      },
      {
        fullValue: 1614,
        timestamp: new Date('2017-06-12T22:21:45.786Z')
      },
      {
        fullValue: 1610,
        timestamp: new Date('2017-06-12T22:01:40.867Z')
      },
      {
        fullValue: 1616,
        timestamp: new Date('2017-06-12T21:41:35.988Z')
      },
      {
        fullValue: 1627,
        timestamp: new Date('2017-06-12T21:22:30.953Z')
      },
      {
        fullValue: 1568,
        timestamp: new Date('2017-06-12T21:02:25.546Z')
      },
      {
        fullValue: 1515,
        timestamp: new Date('2017-06-12T20:42:19.458Z')
      },
      {
        fullValue: 1472,
        timestamp: new Date('2017-06-12T20:22:13.866Z')
      },
      {
        fullValue: 1471,
        timestamp: new Date('2017-06-12T20:02:08.605Z')
      },
      {
        fullValue: 1472,
        timestamp: new Date('2017-06-12T19:42:03.592Z')
      },
      {
        fullValue: 1475,
        timestamp: new Date('2017-06-12T19:21:58.041Z')
      },
      {
        fullValue: 1472,
        timestamp: new Date('2017-06-12T19:01:52.903Z')
      },
      {
        fullValue: 1472,
        timestamp: new Date('2017-06-12T18:40:47.527Z')
      },
      {
        fullValue: 1472,
        timestamp: new Date('2017-06-12T18:20:43.121Z')
      },
      {
        fullValue: 1483,
        timestamp: new Date('2017-06-12T18:00:37.995Z')
      },
      {
        fullValue: 1493,
        timestamp: new Date('2017-06-12T17:40:32.687Z')
      },
      {
        fullValue: 1489,
        timestamp: new Date('2017-06-12T17:19:30.102Z')
      },
      {
        fullValue: 1489,
        timestamp: new Date('2017-06-12T16:59:26.542Z')
      },
      {
        fullValue: 1492,
        timestamp: new Date('2017-06-12T16:39:23.602Z')
      },
      {
        fullValue: 1494,
        timestamp: new Date('2017-06-12T16:19:20.513Z')
      },
      {
        fullValue: 1494,
        timestamp: new Date('2017-06-12T15:59:18.326Z')
      },
      {
        fullValue: 1494,
        timestamp: new Date('2017-06-12T15:39:13.706Z')
      },
      {
        fullValue: 1493,
        timestamp: new Date('2017-06-12T15:19:09.141Z')
      },
      {
        fullValue: 1494,
        timestamp: new Date('2017-06-12T14:59:05.203Z')
      },
      {
        fullValue: 1496,
        timestamp: new Date('2017-06-12T14:39:01.745Z')
      },
      {
        fullValue: 1488,
        timestamp: new Date('2017-06-12T14:18:57.461Z')
      },
      {
        fullValue: 1543,
        timestamp: new Date('2017-06-12T13:48:25.332Z')
      },
      {
        fullValue: 1544,
        timestamp: new Date('2017-06-12T13:28:20.504Z')
      },
      {
        fullValue: 1544,
        timestamp: new Date('2017-06-12T13:08:15.511Z')
      },
      {
        fullValue: 1544,
        timestamp: new Date('2017-06-12T12:48:09.913Z')
      },
      {
        fullValue: 1546,
        timestamp: new Date('2017-06-12T12:28:04.439Z')
      },
      {
        fullValue: 1544,
        timestamp: new Date('2017-06-12T12:07:58.829Z')
      },
      {
        fullValue: 1544,
        timestamp: new Date('2017-06-12T11:47:53.837Z')
      },
      {
        fullValue: 1540,
        timestamp: new Date('2017-06-12T11:27:50.415Z')
      },
      {
        fullValue: 1543,
        timestamp: new Date('2017-06-12T11:07:45.886Z')
      },
      {
        fullValue: 1546,
        timestamp: new Date('2017-06-12T10:47:42.427Z')
      },
      {
        fullValue: 1547,
        timestamp: new Date('2017-06-12T10:27:38.659Z')
      },
      {
        fullValue: 1546,
        timestamp: new Date('2017-06-12T10:07:33.679Z')
      },
      {
        fullValue: 1548,
        timestamp: new Date('2017-06-12T09:47:30.063Z')
      },
      {
        fullValue: 1548,
        timestamp: new Date('2017-06-12T09:27:26.110Z')
      },
      {
        fullValue: 1550,
        timestamp: new Date('2017-06-12T09:07:21.945Z')
      },
      {
        fullValue: 1548,
        timestamp: new Date('2017-06-12T08:47:16.650Z')
      },
      {
        fullValue: 1548,
        timestamp: new Date('2017-06-12T08:27:10.816Z')
      },
      {
        fullValue: 1551,
        timestamp: new Date('2017-06-12T08:07:03.195Z')
      },
      {
        fullValue: 1552,
        timestamp: new Date('2017-06-12T07:46:55.675Z')
      },
      {
        fullValue: 1548,
        timestamp: new Date('2017-06-12T07:26:50.958Z')
      },
      {
        fullValue: 1551,
        timestamp: new Date('2017-06-12T07:06:44.440Z')
      },
      {
        fullValue: 1548,
        timestamp: new Date('2017-06-12T06:46:39.890Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-12T06:26:32.273Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-12T06:06:24.993Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-12T05:46:19.744Z')
      },
      {
        fullValue: 1552,
        timestamp: new Date('2017-06-12T05:26:13.005Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-12T05:06:06.877Z')
      },
      {
        fullValue: 1552,
        timestamp: new Date('2017-06-12T04:46:01.715Z')
      },
      {
        fullValue: 1550,
        timestamp: new Date('2017-06-12T04:25:54.080Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-12T04:05:49.625Z')
      },
      {
        fullValue: 1555,
        timestamp: new Date('2017-06-12T03:45:43.248Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-12T03:25:37.723Z')
      },
      {
        fullValue: 1555,
        timestamp: new Date('2017-06-12T03:05:33.285Z')
      },
      {
        fullValue: 1555,
        timestamp: new Date('2017-06-12T02:45:26.656Z')
      },
      {
        fullValue: 1556,
        timestamp: new Date('2017-06-12T02:25:20.089Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-12T02:05:15.304Z')
      },
      {
        fullValue: 1555,
        timestamp: new Date('2017-06-12T01:45:10.525Z')
      },
      {
        fullValue: 1558,
        timestamp: new Date('2017-06-12T01:25:03.464Z')
      },
      {
        fullValue: 1559,
        timestamp: new Date('2017-06-12T01:04:57.319Z')
      },
      {
        fullValue: 1559,
        timestamp: new Date('2017-06-12T00:44:53.267Z')
      },
      {
        fullValue: 1559,
        timestamp: new Date('2017-06-12T00:24:47.662Z')
      },
      {
        fullValue: 1560,
        timestamp: new Date('2017-06-12T00:04:40.788Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-11T23:44:35.687Z')
      },
      {
        fullValue: 1550,
        timestamp: new Date('2017-06-11T23:24:32.971Z')
      },
      {
        fullValue: 1551,
        timestamp: new Date('2017-06-11T23:04:28.558Z')
      },
      {
        fullValue: 1547,
        timestamp: new Date('2017-06-11T22:43:25.031Z')
      },
      {
        fullValue: 1548,
        timestamp: new Date('2017-06-11T22:23:21.693Z')
      },
      {
        fullValue: 1550,
        timestamp: new Date('2017-06-11T22:03:19.272Z')
      },
      {
        fullValue: 1546,
        timestamp: new Date('2017-06-11T21:43:14.756Z')
      },
      {
        fullValue: 1551,
        timestamp: new Date('2017-06-11T21:23:08.598Z')
      },
      {
        fullValue: 1551,
        timestamp: new Date('2017-06-11T21:03:02.303Z')
      },
      {
        fullValue: 1554,
        timestamp: new Date('2017-06-11T20:42:55.640Z')
      },
      {
        fullValue: 1555,
        timestamp: new Date('2017-06-11T20:22:49.469Z')
      },
      {
        fullValue: 1558,
        timestamp: new Date('2017-06-11T20:02:43.002Z')
      },
      {
        fullValue: 1558,
        timestamp: new Date('2017-06-11T19:42:36.420Z')
      },
      {
        fullValue: 1558,
        timestamp: new Date('2017-06-11T19:22:30.814Z')
      },
      {
        fullValue: 1558,
        timestamp: new Date('2017-06-11T19:02:25.240Z')
      },
      {
        fullValue: 1560,
        timestamp: new Date('2017-06-11T18:42:18.755Z')
      },
      {
        fullValue: 1562,
        timestamp: new Date('2017-06-11T18:22:12.440Z')
      },
      {
        fullValue: 1564,
        timestamp: new Date('2017-06-11T18:02:06.142Z')
      },
      {
        fullValue: 1564,
        timestamp: new Date('2017-06-11T17:41:59.328Z')
      },
      {
        fullValue: 1567,
        timestamp: new Date('2017-06-11T17:21:52.997Z')
      },
      {
        fullValue: 1566,
        timestamp: new Date('2017-06-11T17:01:46.849Z')
      },
      {
        fullValue: 1571,
        timestamp: new Date('2017-06-11T16:41:40.353Z')
      },
      {
        fullValue: 1572,
        timestamp: new Date('2017-06-11T16:21:34.165Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T16:01:27.401Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T15:41:21.077Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-11T15:20:14.502Z')
      },
      {
        fullValue: 1572,
        timestamp: new Date('2017-06-11T15:00:09.038Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-11T14:40:04.389Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-11T14:19:57.876Z')
      },
      {
        fullValue: 1572,
        timestamp: new Date('2017-06-11T13:59:52.105Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T13:39:46.050Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T13:19:38.963Z')
      },
      {
        fullValue: 1571,
        timestamp: new Date('2017-06-11T12:59:34.380Z')
      },
      {
        fullValue: 1568,
        timestamp: new Date('2017-06-11T12:39:29.055Z')
      },
      {
        fullValue: 1569,
        timestamp: new Date('2017-06-11T12:19:23.457Z')
      },
      {
        fullValue: 1569,
        timestamp: new Date('2017-06-11T11:59:17.063Z')
      },
      {
        fullValue: 1571,
        timestamp: new Date('2017-06-11T11:39:11.185Z')
      },
      {
        fullValue: 1572,
        timestamp: new Date('2017-06-11T11:19:04.809Z')
      },
      {
        fullValue: 1571,
        timestamp: new Date('2017-06-11T10:59:00.491Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T10:38:54.763Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-11T10:18:49.161Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-11T09:58:41.666Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-11T09:38:35.997Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-11T09:18:29.889Z')
      },
      {
        fullValue: 1572,
        timestamp: new Date('2017-06-11T08:58:23.985Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T08:38:17.749Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T08:18:10.987Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-11T07:58:04.981Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-11T07:37:59.032Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-11T07:17:52.183Z')
      },
      {
        fullValue: 1577,
        timestamp: new Date('2017-06-11T06:57:46.038Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-11T06:37:39.889Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-11T06:17:32.934Z')
      },
      {
        fullValue: 1577,
        timestamp: new Date('2017-06-11T05:57:25.258Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-11T05:37:20.534Z')
      },
      {
        fullValue: 1577,
        timestamp: new Date('2017-06-11T05:17:13.490Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-11T04:57:07.427Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-11T04:37:01.915Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-11T04:16:56.085Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-11T03:56:49.226Z')
      },
      {
        fullValue: 1580,
        timestamp: new Date('2017-06-11T03:36:43.325Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-11T03:16:38.581Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-11T02:56:31.843Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-11T02:36:26.322Z')
      },
      {
        fullValue: 1569,
        timestamp: new Date('2017-06-11T02:16:20.799Z')
      },
      {
        fullValue: 1568,
        timestamp: new Date('2017-06-11T01:56:14.639Z')
      },
      {
        fullValue: 1572,
        timestamp: new Date('2017-06-11T01:36:08.695Z')
      },
      {
        fullValue: 1572,
        timestamp: new Date('2017-06-11T01:16:02.467Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T00:55:56.489Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-11T00:35:50.394Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-11T00:15:43.771Z')
      },
      {
        fullValue: 1573,
        timestamp: new Date('2017-06-10T23:55:38.064Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-10T23:35:31.364Z')
      },
      {
        fullValue: 1577,
        timestamp: new Date('2017-06-10T23:15:25.391Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-10T22:55:19.197Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-10T22:35:14.135Z')
      },
      {
        fullValue: 1572,
        timestamp: new Date('2017-06-10T22:15:06.865Z')
      },
      {
        fullValue: 1568,
        timestamp: new Date('2017-06-10T21:55:01.013Z')
      },
      {
        fullValue: 1569,
        timestamp: new Date('2017-06-10T21:34:55.047Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-10T21:14:51.338Z')
      },
      {
        fullValue: 1575,
        timestamp: new Date('2017-06-10T20:54:48.647Z')
      },
      {
        fullValue: 1576,
        timestamp: new Date('2017-06-10T20:34:45.928Z')
      },
      {
        fullValue: 1580,
        timestamp: new Date('2017-06-10T20:14:43.451Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T19:54:41.019Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T19:34:37.936Z')
      },
      {
        fullValue: 1581,
        timestamp: new Date('2017-06-10T19:14:35.196Z')
      },
      {
        fullValue: 1584,
        timestamp: new Date('2017-06-10T18:54:31.643Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T18:34:26.074Z')
      },
      {
        fullValue: 1587,
        timestamp: new Date('2017-06-10T18:14:23.590Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T17:54:20.002Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T17:34:16.297Z')
      },
      {
        fullValue: 1588,
        timestamp: new Date('2017-06-10T17:14:13.462Z')
      },
      {
        fullValue: 1588,
        timestamp: new Date('2017-06-10T16:54:09.955Z')
      },
      {
        fullValue: 1588,
        timestamp: new Date('2017-06-10T16:34:06.340Z')
      },
      {
        fullValue: 1593,
        timestamp: new Date('2017-06-10T16:14:03.529Z')
      },
      {
        fullValue: 1589,
        timestamp: new Date('2017-06-10T15:54:01.017Z')
      },
      {
        fullValue: 1592,
        timestamp: new Date('2017-06-10T15:33:58.180Z')
      },
      {
        fullValue: 1587,
        timestamp: new Date('2017-06-10T15:13:51.796Z')
      },
      {
        fullValue: 1588,
        timestamp: new Date('2017-06-10T14:53:45.278Z')
      },
      {
        fullValue: 1584,
        timestamp: new Date('2017-06-10T14:33:40.857Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T14:13:35.002Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T13:53:28.680Z')
      },
      {
        fullValue: 1588,
        timestamp: new Date('2017-06-10T13:33:23.024Z')
      },
      {
        fullValue: 1583,
        timestamp: new Date('2017-06-10T13:13:17.763Z')
      },
      {
        fullValue: 1587,
        timestamp: new Date('2017-06-10T12:53:10.829Z')
      },
      {
        fullValue: 1592,
        timestamp: new Date('2017-06-10T12:33:05.334Z')
      },
      {
        fullValue: 1593,
        timestamp: new Date('2017-06-10T12:12:59.099Z')
      },
      {
        fullValue: 1592,
        timestamp: new Date('2017-06-10T11:52:53.880Z')
      },
      {
        fullValue: 1595,
        timestamp: new Date('2017-06-10T11:32:46.723Z')
      },
      {
        fullValue: 1592,
        timestamp: new Date('2017-06-10T11:12:38.811Z')
      },
      {
        fullValue: 1583,
        timestamp: new Date('2017-06-10T10:52:34.295Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-10T10:32:29.365Z')
      },
      {
        fullValue: 1579,
        timestamp: new Date('2017-06-10T10:12:25.012Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T09:52:18.187Z')
      },
      {
        fullValue: 1584,
        timestamp: new Date('2017-06-10T09:31:13.190Z')
      },
      {
        fullValue: 1587,
        timestamp: new Date('2017-06-10T09:11:06.647Z')
      },
      {
        fullValue: 1589,
        timestamp: new Date('2017-06-10T08:51:00.312Z')
      },
      {
        fullValue: 1587,
        timestamp: new Date('2017-06-10T08:30:54.964Z')
      },
      {
        fullValue: 1596,
        timestamp: new Date('2017-06-10T08:10:48.904Z')
      },
      {
        fullValue: 1596,
        timestamp: new Date('2017-06-10T07:50:42.167Z')
      },
      {
        fullValue: 1592,
        timestamp: new Date('2017-06-10T07:30:34.361Z')
      },
      {
        fullValue: 1593,
        timestamp: new Date('2017-06-10T07:10:27.811Z')
      },
      {
        fullValue: 1591,
        timestamp: new Date('2017-06-10T06:50:24.248Z')
      },
      {
        fullValue: 1587,
        timestamp: new Date('2017-06-10T06:30:21.703Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T06:10:17.041Z')
      },
      {
        fullValue: 1585,
        timestamp: new Date('2017-06-10T05:50:10.123Z')
      },
      {
        fullValue: 1584,
        timestamp: new Date('2017-06-10T05:30:04.628Z')
      },
      {
        fullValue: 1584,
        timestamp: new Date('2017-06-10T05:09:59.723Z')
      },
      {
        fullValue: 1589,
        timestamp: new Date('2017-06-10T04:49:56.027Z')
      },
      {
        fullValue: 1591,
        timestamp: new Date('2017-06-10T04:29:52.873Z')
      },
      {
        fullValue: 1589,
        timestamp: new Date('2017-06-10T04:09:49.180Z')
      },
      {
        fullValue: 1592,
        timestamp: new Date('2017-06-10T03:49:45.562Z')
      },
      {
        fullValue: 1597,
        timestamp: new Date('2017-06-10T03:29:42.492Z')
      },
      {
        fullValue: 1595,
        timestamp: new Date('2017-06-10T03:09:38.925Z')
      },
      {
        fullValue: 1596,
        timestamp: new Date('2017-06-10T02:49:32.408Z')
      },
      {
        fullValue: 1595,
        timestamp: new Date('2017-06-10T02:29:26.543Z')
      },
      {
        fullValue: 1592,
        timestamp: new Date('2017-06-10T02:09:21.743Z')
      },
      {
        fullValue: 1608,
        timestamp: new Date('2017-06-10T01:49:15.450Z')
      },
      {
        fullValue: 1608,
        timestamp: new Date('2017-06-10T01:29:11.875Z')
      },
      {
        fullValue: 1605,
        timestamp: new Date('2017-06-10T01:09:07.968Z')
      },
      {
        fullValue: 1608,
        timestamp: new Date('2017-06-10T00:49:10.033Z')
      },
      {
        fullValue: 1610,
        timestamp: new Date('2017-06-10T00:30:24.943Z')
      },
      {
        fullValue: 1610,
        timestamp: new Date('2017-06-10T00:12:17.509Z')
      },
      {
        fullValue: 1621,
        timestamp: new Date('2017-06-09T23:51:54.672Z')
      },
      {
        fullValue: 1577,
        timestamp: new Date('2017-06-09T23:31:48.108Z')
      },
      {
        fullValue: 1531,
        timestamp: new Date('2017-06-09T23:11:42.825Z')
      },
      {
        fullValue: 1479,
        timestamp: new Date('2017-06-09T22:50:37.333Z')
      },
      {
        fullValue: 1432,
        timestamp: new Date('2017-06-09T22:30:31.551Z')
      },
      {
        fullValue: 1381,
        timestamp: new Date('2017-06-09T22:10:25.398Z')
      },
      {
        fullValue: 1330,
        timestamp: new Date('2017-06-09T21:46:56.125Z')
      },
      {
        fullValue: 1206,
        timestamp: new Date('2017-06-09T21:26:50.226Z')
      },
      {
        fullValue: 1161,
        timestamp: new Date('2017-06-09T21:06:44.526Z')
      },
      {
        fullValue: 1596,
        timestamp: new Date('2017-06-09T20:46:38.811Z')
      },
      {
        fullValue: 1887,
        timestamp: new Date('2017-06-09T20:26:32.895Z')
      },
      {
        fullValue: 1895,
        timestamp: new Date('2017-06-09T20:06:26.043Z')
      },
      {
        fullValue: 1900,
        timestamp: new Date('2017-06-09T19:46:19.739Z')
      },
      {
        fullValue: 1902,
        timestamp: new Date('2017-06-09T19:26:14.781Z')
      },
      {
        fullValue: 1903,
        timestamp: new Date('2017-06-09T19:06:10.429Z')
      },
      {
        fullValue: 1907,
        timestamp: new Date('2017-06-09T18:46:05.832Z')
      },
      {
        fullValue: 1906,
        timestamp: new Date('2017-06-09T18:26:00.164Z')
      },
      {
        fullValue: 1911,
        timestamp: new Date('2017-06-09T18:05:53.626Z')
      },
      {
        fullValue: 1915,
        timestamp: new Date('2017-06-09T17:45:48.057Z')
      },
      {
        fullValue: 1915,
        timestamp: new Date('2017-06-09T17:25:41.379Z')
      },
      {
        fullValue: 1912,
        timestamp: new Date('2017-06-09T17:05:34.693Z')
      },
      {
        fullValue: 1912,
        timestamp: new Date('2017-06-09T16:45:27.966Z')
      },
      {
        fullValue: 1913,
        timestamp: new Date('2017-06-09T16:25:21.118Z')
      },
      {
        fullValue: 1921,
        timestamp: new Date('2017-06-09T16:05:14.670Z')
      },
      {
        fullValue: 1928,
        timestamp: new Date('2017-06-09T15:45:11.086Z')
      },
      {
        fullValue: 1929,
        timestamp: new Date('2017-06-09T15:25:06.615Z')
      },
      {
        fullValue: 1929,
        timestamp: new Date('2017-06-09T15:05:01.727Z')
      },
      {
        fullValue: 1929,
        timestamp: new Date('2017-06-09T14:45:57.694Z')
      },
      {
        fullValue: 1932,
        timestamp: new Date('2017-06-09T14:25:52.095Z')
      },
      {
        fullValue: 1927,
        timestamp: new Date('2017-06-09T14:05:44.667Z')
      },
      {
        fullValue: 1929,
        timestamp: new Date('2017-06-09T13:45:38.046Z')
      },
      {
        fullValue: 1929,
        timestamp: new Date('2017-06-09T13:25:32.434Z')
      },
      {
        fullValue: 1931,
        timestamp: new Date('2017-06-09T13:05:26.166Z')
      },
      {
        fullValue: 1927,
        timestamp: new Date('2017-06-09T12:45:19.023Z')
      },
      {
        fullValue: 1931,
        timestamp: new Date('2017-06-09T12:25:13.461Z')
      },
      {
        fullValue: 1928,
        timestamp: new Date('2017-06-09T12:05:08.633Z')
      },
      {
        fullValue: 1925,
        timestamp: new Date('2017-06-09T11:45:00.823Z')
      },
      {
        fullValue: 1929,
        timestamp: new Date('2017-06-09T11:24:53.679Z')
      },
      {
        fullValue: 1931,
        timestamp: new Date('2017-06-09T11:04:48.919Z')
      },
      {
        fullValue: 1924,
        timestamp: new Date('2017-06-09T10:44:41.192Z')
      },
      {
        fullValue: 1931,
        timestamp: new Date('2017-06-09T10:24:35.084Z')
      },
      {
        fullValue: 1925,
        timestamp: new Date('2017-06-09T10:04:28.542Z')
      },
      {
        fullValue: 1925,
        timestamp: new Date('2017-06-09T09:44:23.283Z')
      },
      {
        fullValue: 1928,
        timestamp: new Date('2017-06-09T09:24:15.566Z')
      },
      {
        fullValue: 1923,
        timestamp: new Date('2017-06-09T09:04:08.046Z')
      },
      {
        fullValue: 1925,
        timestamp: new Date('2017-06-09T08:44:02.279Z')
      },
      {
        fullValue: 1923,
        timestamp: new Date('2017-06-09T08:23:55.619Z')
      },
      {
        fullValue: 1923,
        timestamp: new Date('2017-06-09T08:03:47.942Z')
      },
      {
        fullValue: 1925,
        timestamp: new Date('2017-06-09T07:43:42.753Z')
      },
      {
        fullValue: 1920,
        timestamp: new Date('2017-06-09T07:23:35.105Z')
      },
      {
        fullValue: 1921,
        timestamp: new Date('2017-06-09T07:03:29.098Z')
      },
      {
        fullValue: 1923,
        timestamp: new Date('2017-06-09T06:43:23.004Z')
      },
      {
        fullValue: 1924,
        timestamp: new Date('2017-06-09T06:23:17.353Z')
      },
      {
        fullValue: 1927,
        timestamp: new Date('2017-06-09T06:03:09.789Z')
      },
      {
        fullValue: 1919,
        timestamp: new Date('2017-06-09T05:43:02.100Z')
      },
      {
        fullValue: 1921,
        timestamp: new Date('2017-06-09T05:22:57.075Z')
      },
      {
        fullValue: 1917,
        timestamp: new Date('2017-06-09T05:02:51.157Z')
      },
      {
        fullValue: 1921,
        timestamp: new Date('2017-06-09T04:42:44.901Z')
      },
      {
        fullValue: 1924,
        timestamp: new Date('2017-06-09T04:22:38.561Z')
      },
      {
        fullValue: 1924,
        timestamp: new Date('2017-06-09T04:02:34.037Z')
      },
      {
        fullValue: 1920,
        timestamp: new Date('2017-06-09T03:42:27.307Z')
      },
      {
        fullValue: 1919,
        timestamp: new Date('2017-06-09T03:22:19.639Z')
      },
      {
        fullValue: 1919,
        timestamp: new Date('2017-06-09T03:02:13.069Z')
      },
      {
        fullValue: 1916,
        timestamp: new Date('2017-06-09T02:42:08.660Z')
      },
      {
        fullValue: 1916,
        timestamp: new Date('2017-06-09T02:22:02.693Z')
      },
      {
        fullValue: 1920,
        timestamp: new Date('2017-06-09T02:01:57.061Z')
      },
      {
        fullValue: 1920,
        timestamp: new Date('2017-06-09T01:41:50.541Z')
      },
      {
        fullValue: 1906,
        timestamp: new Date('2017-06-09T01:21:43.421Z')
      },
      {
        fullValue: 1907,
        timestamp: new Date('2017-06-09T01:01:35.927Z')
      },
      {
        fullValue: 1903,
        timestamp: new Date('2017-06-09T00:41:28.761Z')
      },
      {
        fullValue: 1896,
        timestamp: new Date('2017-06-09T00:21:23.873Z')
      },
      {
        fullValue: 1900,
        timestamp: new Date('2017-06-09T00:01:17.408Z')
      },
      {
        fullValue: 1904,
        timestamp: new Date('2017-06-08T23:41:11.386Z')
      },
      {
        fullValue: 1913,
        timestamp: new Date('2017-06-08T23:21:06.227Z')
      },
      {
        fullValue: 1912,
        timestamp: new Date('2017-06-08T23:01:01.330Z')
      },
      {
        fullValue: 1907,
        timestamp: new Date('2017-06-08T22:40:53.517Z')
      },
      {
        fullValue: 1895,
        timestamp: new Date('2017-06-08T22:20:46.266Z')
      },
      {
        fullValue: 1912,
        timestamp: new Date('2017-06-08T22:00:40.642Z')
      },
      {
        fullValue: 1906,
        timestamp: new Date('2017-06-08T21:40:34.607Z')
      },
      {
        fullValue: 1909,
        timestamp: new Date('2017-06-08T21:20:30.134Z')
      },
      {
        fullValue: 1916,
        timestamp: new Date('2017-06-08T21:00:26.398Z')
      },
      {
        fullValue: 1919,
        timestamp: new Date('2017-06-08T20:40:20.971Z')
      },
      {
        fullValue: 1912,
        timestamp: new Date('2017-06-08T20:20:14.408Z')
      },
      {
        fullValue: 1903,
        timestamp: new Date('2017-06-08T20:00:09.018Z')
      },
      {
        fullValue: 1904,
        timestamp: new Date('2017-06-08T19:40:02.506Z')
      },
      {
        fullValue: 1907,
        timestamp: new Date('2017-06-08T19:19:55.993Z')
      },
      {
        fullValue: 1912,
        timestamp: new Date('2017-06-08T18:59:50.834Z')
      },
      {
        fullValue: 1912,
        timestamp: new Date('2017-06-08T18:39:47.601Z')
      },
      {
        fullValue: 1915,
        timestamp: new Date('2017-06-08T18:19:45.157Z')
      },
      {
        fullValue: 1917,
        timestamp: new Date('2017-06-08T17:59:42.089Z')
      },
      {
        fullValue: 1917,
        timestamp: new Date('2017-06-08T17:40:38.334Z')
      },
      {
        fullValue: 1916,
        timestamp: new Date('2017-06-08T17:20:33.287Z')
      },
      {
        fullValue: 1917,
        timestamp: new Date('2017-06-08T17:00:29.717Z')
      },
      {
        fullValue: 1917,
        timestamp: new Date('2017-06-08T16:40:25.950Z')
      },
      {
        fullValue: 1909,
        timestamp: new Date('2017-06-08T16:20:23.259Z')
      },
      {
        fullValue: 1911,
        timestamp: new Date('2017-06-08T16:00:20.582Z')
      },
      {
        fullValue: 1906,
        timestamp: new Date('2017-06-08T15:40:17.831Z')
      },
      {
        fullValue: 1899,
        timestamp: new Date('2017-06-08T15:20:14.953Z')
      },
      {
        fullValue: 1894,
        timestamp: new Date('2017-06-08T15:00:08.565Z')
      },
      {
        fullValue: 1895,
        timestamp: new Date('2017-06-08T14:40:03.127Z')
      },
      {
        fullValue: 1894,
        timestamp: new Date('2017-06-08T14:19:57.347Z')
      },
      {
        fullValue: 1894,
        timestamp: new Date('2017-06-08T13:59:51.132Z')
      },
      {
        fullValue: 1892,
        timestamp: new Date('2017-06-08T13:39:45.549Z')
      },
      {
        fullValue: 1890,
        timestamp: new Date('2017-06-08T13:19:39.570Z')
      },
      {
        fullValue: 1892,
        timestamp: new Date('2017-06-08T12:59:33.222Z')
      },
      {
        fullValue: 1891,
        timestamp: new Date('2017-06-08T12:39:27.480Z')
      },
      {
        fullValue: 1886,
        timestamp: new Date('2017-06-08T12:19:20.651Z')
      },
      {
        fullValue: 1886,
        timestamp: new Date('2017-06-08T11:59:14.911Z')
      },
      {
        fullValue: 1879,
        timestamp: new Date('2017-06-08T11:39:07.982Z')
      },
      {
        fullValue: 1874,
        timestamp: new Date('2017-06-08T11:19:01.178Z')
      },
      {
        fullValue: 1861,
        timestamp: new Date('2017-06-08T10:58:55.017Z')
      },
      {
        fullValue: 1859,
        timestamp: new Date('2017-06-08T10:38:49.539Z')
      },
      {
        fullValue: 1859,
        timestamp: new Date('2017-06-08T10:18:44.040Z')
      },
      {
        fullValue: 1859,
        timestamp: new Date('2017-06-08T09:57:37.272Z')
      },
      {
        fullValue: 1863,
        timestamp: new Date('2017-06-08T09:37:31.661Z')
      },
      {
        fullValue: 1857,
        timestamp: new Date('2017-06-08T09:17:26.112Z')
      },
      {
        fullValue: 1859,
        timestamp: new Date('2017-06-08T08:57:21.079Z')
      },
      {
        fullValue: 1857,
        timestamp: new Date('2017-06-08T08:37:14.706Z')
      },
      {
        fullValue: 1862,
        timestamp: new Date('2017-06-08T08:17:08.624Z')
      },
      {
        fullValue: 1851,
        timestamp: new Date('2017-06-08T07:57:02.953Z')
      },
      {
        fullValue: 1850,
        timestamp: new Date('2017-06-08T07:35:57.466Z')
      },
      {
        fullValue: 1850,
        timestamp: new Date('2017-06-08T07:13:49.854Z')
      },
      {
        fullValue: 1841,
        timestamp: new Date('2017-06-08T06:53:42.776Z')
      },
      {
        fullValue: 1834,
        timestamp: new Date('2017-06-08T06:33:38.198Z')
      },
      {
        fullValue: 1828,
        timestamp: new Date('2017-06-08T06:11:31.186Z')
      },
      {
        fullValue: 1825,
        timestamp: new Date('2017-06-08T05:51:25.594Z')
      },
      {
        fullValue: 1828,
        timestamp: new Date('2017-06-08T05:31:19.499Z')
      },
      {
        fullValue: 1825,
        timestamp: new Date('2017-06-08T05:11:13.733Z')
      },
      {
        fullValue: 1828,
        timestamp: new Date('2017-06-08T04:51:07.615Z')
      },
      {
        fullValue: 1823,
        timestamp: new Date('2017-06-08T04:31:02.004Z')
      },
      {
        fullValue: 1825,
        timestamp: new Date('2017-06-08T04:06:54.115Z')
      },
      {
        fullValue: 1823,
        timestamp: new Date('2017-06-08T03:46:48.377Z')
      },
      {
        fullValue: 1826,
        timestamp: new Date('2017-06-08T03:26:42.565Z')
      },
      {
        fullValue: 1821,
        timestamp: new Date('2017-06-08T03:06:36.667Z')
      },
      {
        fullValue: 1816,
        timestamp: new Date('2017-06-08T02:46:30.808Z')
      },
      {
        fullValue: 1808,
        timestamp: new Date('2017-06-08T02:26:23.735Z')
      },
      {
        fullValue: 1803,
        timestamp: new Date('2017-06-08T02:06:16.685Z')
      },
      {
        fullValue: 1787,
        timestamp: new Date('2017-06-08T01:46:09.705Z')
      },
      {
        fullValue: 1786,
        timestamp: new Date('2017-06-08T01:26:04.166Z')
      },
      {
        fullValue: 1784,
        timestamp: new Date('2017-06-08T01:05:57.971Z')
      },
      {
        fullValue: 1782,
        timestamp: new Date('2017-06-08T00:45:53.217Z')
      },
      {
        fullValue: 1779,
        timestamp: new Date('2017-06-08T00:25:46.893Z')
      },
      {
        fullValue: 1776,
        timestamp: new Date('2017-06-08T00:05:41.403Z')
      },
      {
        fullValue: 1776,
        timestamp: new Date('2017-06-07T23:45:35.988Z')
      },
      {
        fullValue: 1776,
        timestamp: new Date('2017-06-07T23:25:29.483Z')
      },
      {
        fullValue: 1788,
        timestamp: new Date('2017-06-07T23:05:23.837Z')
      },
      {
        fullValue: 1786,
        timestamp: new Date('2017-06-07T22:45:16.894Z')
      },
      {
        fullValue: 1778,
        timestamp: new Date('2017-06-07T22:25:09.773Z')
      },
      {
        fullValue: 1766,
        timestamp: new Date('2017-06-07T22:05:02.650Z')
      },
      {
        fullValue: 1763,
        timestamp: new Date('2017-06-07T21:44:55.767Z')
      },
      {
        fullValue: 1753,
        timestamp: new Date('2017-06-07T21:24:50.155Z')
      },
      {
        fullValue: 1758,
        timestamp: new Date('2017-06-07T21:04:45.711Z')
      },
      {
        fullValue: 1757,
        timestamp: new Date('2017-06-07T20:44:41.889Z')
      },
      {
        fullValue: 1761,
        timestamp: new Date('2017-06-07T20:24:36.581Z')
      },
      {
        fullValue: 1766,
        timestamp: new Date('2017-06-07T20:04:32.331Z')
      },
      {
        fullValue: 1766,
        timestamp: new Date('2017-06-07T19:44:30.353Z')
      },
      {
        fullValue: 1765,
        timestamp: new Date('2017-06-07T19:20:53.206Z')
      },
      {
        fullValue: 1766,
        timestamp: new Date('2017-06-07T19:00:48.916Z')
      },
      {
        fullValue: 1763,
        timestamp: new Date('2017-06-07T18:38:51.621Z')
      },
      {
        fullValue: 1762,
        timestamp: new Date('2017-06-07T18:15:14.418Z')
      },
      {
        fullValue: 1759,
        timestamp: new Date('2017-06-07T17:53:10.469Z')
      },
      {
        fullValue: 1759,
        timestamp: new Date('2017-06-07T17:33:04.474Z')
      },
      {
        fullValue: 1751,
        timestamp: new Date('2017-06-07T17:13:00.618Z')
      },
      {
        fullValue: 1750,
        timestamp: new Date('2017-06-07T16:51:55.500Z')
      },
      {
        fullValue: 1749,
        timestamp: new Date('2017-06-07T16:31:51.477Z')
      },
      {
        fullValue: 1728,
        timestamp: new Date('2017-06-07T16:06:24.878Z')
      },
      {
        fullValue: 1721,
        timestamp: new Date('2017-06-07T15:46:19.704Z')
      },
      {
        fullValue: 1720,
        timestamp: new Date('2017-06-07T15:27:14.182Z')
      },
      {
        fullValue: 1708,
        timestamp: new Date('2017-06-07T15:07:09.454Z')
      },
      {
        fullValue: 1701,
        timestamp: new Date('2017-06-07T14:47:03.892Z')
      },
      {
        fullValue: 1701,
        timestamp: new Date('2017-06-07T14:26:58.106Z')
      },
      {
        fullValue: 1691,
        timestamp: new Date('2017-06-07T14:06:51.765Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T13:46:47.495Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T13:26:41.270Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-07T13:06:35.232Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-07T12:46:29.429Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T12:26:23.561Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T12:06:19.449Z')
      },
      {
        fullValue: 1645,
        timestamp: new Date('2017-06-07T11:46:13.167Z')
      },
      {
        fullValue: 1645,
        timestamp: new Date('2017-06-07T11:26:07.078Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T11:06:00.597Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T10:45:55.351Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T10:25:50.697Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T10:05:44.763Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-07T09:45:38.847Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T09:25:32.338Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T09:05:26.946Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T08:45:20.936Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T08:25:15.544Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T08:05:10.716Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T07:45:05.325Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-07T07:24:59.847Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-07T07:04:53.517Z')
      },
      {
        fullValue: 1638,
        timestamp: new Date('2017-06-07T06:44:49.574Z')
      },
      {
        fullValue: 1639,
        timestamp: new Date('2017-06-07T06:24:43.934Z')
      },
      {
        fullValue: 1637,
        timestamp: new Date('2017-06-07T06:04:37.950Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-07T05:44:31.647Z')
      },
      {
        fullValue: 1633,
        timestamp: new Date('2017-06-07T05:24:27.955Z')
      },
      {
        fullValue: 1633,
        timestamp: new Date('2017-06-07T05:04:22.058Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-07T04:44:16.285Z')
      },
      {
        fullValue: 1639,
        timestamp: new Date('2017-06-07T04:24:11.453Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T04:03:05.778Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-07T03:43:00.049Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T03:21:53.316Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-07T03:01:49.578Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T02:41:43.588Z')
      },
      {
        fullValue: 1639,
        timestamp: new Date('2017-06-07T02:21:37.957Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-07T02:01:32.651Z')
      },
      {
        fullValue: 1639,
        timestamp: new Date('2017-06-07T01:41:26.939Z')
      },
      {
        fullValue: 1638,
        timestamp: new Date('2017-06-07T01:21:21.722Z')
      },
      {
        fullValue: 1637,
        timestamp: new Date('2017-06-07T01:01:15.819Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-07T00:41:10.351Z')
      },
      {
        fullValue: 1633,
        timestamp: new Date('2017-06-07T00:21:05.146Z')
      },
      {
        fullValue: 1629,
        timestamp: new Date('2017-06-07T00:00:59.540Z')
      },
      {
        fullValue: 1627,
        timestamp: new Date('2017-06-06T23:40:54.586Z')
      },
      {
        fullValue: 1630,
        timestamp: new Date('2017-06-06T23:20:49.233Z')
      },
      {
        fullValue: 1630,
        timestamp: new Date('2017-06-06T23:00:44.183Z')
      },
      {
        fullValue: 1629,
        timestamp: new Date('2017-06-06T22:40:39.485Z')
      },
      {
        fullValue: 1629,
        timestamp: new Date('2017-06-06T22:20:33.611Z')
      },
      {
        fullValue: 1635,
        timestamp: new Date('2017-06-06T22:00:28.379Z')
      },
      {
        fullValue: 1645,
        timestamp: new Date('2017-06-06T21:40:22.546Z')
      },
      {
        fullValue: 1645,
        timestamp: new Date('2017-06-06T21:20:18.381Z')
      },
      {
        fullValue: 1647,
        timestamp: new Date('2017-06-06T21:00:14.421Z')
      },
      {
        fullValue: 1649,
        timestamp: new Date('2017-06-06T20:40:10.602Z')
      },
      {
        fullValue: 1646,
        timestamp: new Date('2017-06-06T20:20:06.729Z')
      },
      {
        fullValue: 1646,
        timestamp: new Date('2017-06-06T20:00:02.707Z')
      },
      {
        fullValue: 1643,
        timestamp: new Date('2017-06-06T19:39:59.578Z')
      },
      {
        fullValue: 1646,
        timestamp: new Date('2017-06-06T19:16:13.106Z')
      },
      {
        fullValue: 1646,
        timestamp: new Date('2017-06-06T18:56:09.087Z')
      },
      {
        fullValue: 1649,
        timestamp: new Date('2017-06-06T18:36:05.216Z')
      },
      {
        fullValue: 1647,
        timestamp: new Date('2017-06-06T18:16:01.274Z')
      },
      {
        fullValue: 1645,
        timestamp: new Date('2017-06-06T17:55:57.416Z')
      },
      {
        fullValue: 1646,
        timestamp: new Date('2017-06-06T17:35:53.714Z')
      },
      {
        fullValue: 1645,
        timestamp: new Date('2017-06-06T17:15:50.318Z')
      },
      {
        fullValue: 1645,
        timestamp: new Date('2017-06-06T16:55:46.419Z')
      },
      {
        fullValue: 1647,
        timestamp: new Date('2017-06-06T16:35:42.753Z')
      },
      {
        fullValue: 1647,
        timestamp: new Date('2017-06-06T16:15:39.570Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-06T15:55:33.686Z')
      },
      {
        fullValue: 1638,
        timestamp: new Date('2017-06-06T15:35:31.019Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-06T15:15:26.108Z')
      },
      {
        fullValue: 1641,
        timestamp: new Date('2017-06-06T14:55:21.007Z')
      },
      {
        fullValue: 1642,
        timestamp: new Date('2017-06-06T14:35:16.251Z')
      },
      {
        fullValue: 1649,
        timestamp: new Date('2017-06-06T14:15:10.664Z')
      },
      {
        fullValue: 1647,
        timestamp: new Date('2017-06-06T13:55:06.687Z')
      },
      {
        fullValue: 1654,
        timestamp: new Date('2017-06-06T13:35:03.110Z')
      },
      {
        fullValue: 1646,
        timestamp: new Date('2017-06-06T13:14:58.222Z')
      },
      {
        fullValue: 1639,
        timestamp: new Date('2017-06-06T12:54:53.537Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-06T12:34:47.222Z')
      },
      {
        fullValue: 1633,
        timestamp: new Date('2017-06-06T12:14:42.788Z')
      },
      {
        fullValue: 1635,
        timestamp: new Date('2017-06-06T11:54:37.788Z')
      },
      {
        fullValue: 1625,
        timestamp: new Date('2017-06-06T11:34:33.374Z')
      },
      {
        fullValue: 1635,
        timestamp: new Date('2017-06-06T11:14:29.245Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-06T10:54:24.922Z')
      },
      {
        fullValue: 1635,
        timestamp: new Date('2017-06-06T10:34:20.412Z')
      },
      {
        fullValue: 1627,
        timestamp: new Date('2017-06-06T10:14:15.728Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-06T09:54:10.068Z')
      },
      {
        fullValue: 1633,
        timestamp: new Date('2017-06-06T09:34:06.560Z')
      },
      {
        fullValue: 1625,
        timestamp: new Date('2017-06-06T09:14:01.652Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-06T08:53:58.096Z')
      },
      {
        fullValue: 1629,
        timestamp: new Date('2017-06-06T08:33:53.339Z')
      },
      {
        fullValue: 1626,
        timestamp: new Date('2017-06-06T08:13:49.070Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-06T07:53:45.356Z')
      },
      {
        fullValue: 1626,
        timestamp: new Date('2017-06-06T07:33:41.461Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-06T07:13:36.406Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-06T06:53:32.487Z')
      },
      {
        fullValue: 1625,
        timestamp: new Date('2017-06-06T06:33:27.630Z')
      },
      {
        fullValue: 1635,
        timestamp: new Date('2017-06-06T06:13:23.912Z')
      },
      {
        fullValue: 1629,
        timestamp: new Date('2017-06-06T05:53:17.816Z')
      },
      {
        fullValue: 1626,
        timestamp: new Date('2017-06-06T05:33:13.185Z')
      },
      {
        fullValue: 1635,
        timestamp: new Date('2017-06-06T05:13:09.278Z')
      },
      {
        fullValue: 1627,
        timestamp: new Date('2017-06-06T04:53:04.808Z')
      },
      {
        fullValue: 1627,
        timestamp: new Date('2017-06-06T04:32:59.029Z')
      },
      {
        fullValue: 1633,
        timestamp: new Date('2017-06-06T04:12:55.262Z')
      },
      {
        fullValue: 1625,
        timestamp: new Date('2017-06-06T03:52:50.798Z')
      },
      {
        fullValue: 1637,
        timestamp: new Date('2017-06-06T03:32:46.881Z')
      },
      {
        fullValue: 1633,
        timestamp: new Date('2017-06-06T03:12:43.013Z')
      },
      {
        fullValue: 1624,
        timestamp: new Date('2017-06-06T02:52:40.229Z')
      },
      {
        fullValue: 1638,
        timestamp: new Date('2017-06-06T02:32:36.279Z')
      },
      {
        fullValue: 1631,
        timestamp: new Date('2017-06-06T02:12:32.513Z')
      },
      {
        fullValue: 1625,
        timestamp: new Date('2017-06-06T01:52:29.684Z')
      },
      {
        fullValue: 1634,
        timestamp: new Date('2017-06-06T01:32:26.115Z')
      }
    ],
    error: null
  }
}



// WEBPACK FOOTER //
// ./containers/Analyze/historicalDataByRegister.js